// Données ARCHIVÉES du bilan de présences — Année scolaire 2025/2026
// ⚠️ Fichier généré une seule fois à partir de l'export Excel (resume_presences.csv).
// Ces données sont STATIQUES : elles ne se mettent PAS à jour automatiquement.
// Si la collection "presences" est réinitialisée / vidée en base, ce fichier reste
// la seule trace du bilan de l'année 2025/2026. Pour archiver une nouvelle année,
// dupliquez ce fichier (ex: studentsArchive2026_2027.js) et régénérez les données.

export const ANNEE_SCOLAIRE = '2025/2026';

// Date à laquelle ce bilan a été figé (à adapter si vous régénérez le fichier)
export const DATE_ARCHIVAGE = '2026-09-01';

export const studentsArchive2025_2026 = [
  {
    "nom": "MALAK AMINE",
    "codeMassar": "R131935842",
    "niveau": "2BAC PC",
    "totalSessions": 153,
    "totalPresences": 47,
    "totalAbsences": 106,
    "totalRetardMinutes": 0,
    "tauxPresence": 30.7
  },
  {
    "nom": "MANAL MARGHICHE",
    "codeMassar": "F177184032",
    "niveau": "3AC",
    "totalSessions": 147,
    "totalPresences": 62,
    "totalAbsences": 85,
    "totalRetardMinutes": 0,
    "tauxPresence": 42.2
  },
  {
    "nom": "YASSINE LAARIBI",
    "codeMassar": "R154065930",
    "niveau": "1BAC SC",
    "totalSessions": 155,
    "totalPresences": 76,
    "totalAbsences": 79,
    "totalRetardMinutes": 30,
    "tauxPresence": 49.0
  },
  {
    "nom": "HAFSA OUASSINE",
    "codeMassar": "R141188964",
    "niveau": "2BAC PC",
    "totalSessions": 212,
    "totalPresences": 140,
    "totalAbsences": 72,
    "totalRetardMinutes": 75,
    "tauxPresence": 66.0
  },
  {
    "nom": "HAFID MOHAMED ESSEDDIK",
    "codeMassar": "R154069510",
    "niveau": "2BAC Économie",
    "totalSessions": 131,
    "totalPresences": 63,
    "totalAbsences": 68,
    "totalRetardMinutes": 80,
    "tauxPresence": 48.1
  },
  {
    "nom": "BOUMICHI MOHAMED AMINE",
    "codeMassar": "R153052414",
    "niveau": "2BAC Économie",
    "totalSessions": 132,
    "totalPresences": 65,
    "totalAbsences": 67,
    "totalRetardMinutes": 15,
    "tauxPresence": 49.2
  },
  {
    "nom": "MOHAMAD AMINE DAHMI",
    "codeMassar": "F192081378",
    "niveau": "2AC",
    "totalSessions": 168,
    "totalPresences": 102,
    "totalAbsences": 66,
    "totalRetardMinutes": 45,
    "tauxPresence": 60.7
  },
  {
    "nom": "MAROUANE MBARKI",
    "codeMassar": "F178210312",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 179,
    "totalAbsences": 65,
    "totalRetardMinutes": 224,
    "tauxPresence": 73.4
  },
  {
    "nom": "KARAMI WASSIM",
    "codeMassar": "R147171659",
    "niveau": "2BAC Économie",
    "totalSessions": 141,
    "totalPresences": 83,
    "totalAbsences": 58,
    "totalRetardMinutes": 155,
    "tauxPresence": 58.9
  },
  {
    "nom": "AMINA ELOUATI",
    "codeMassar": "R148159259",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 165,
    "totalAbsences": 51,
    "totalRetardMinutes": 45,
    "tauxPresence": 76.4
  },
  {
    "nom": "NADA SALMI",
    "codeMassar": "R148151228",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 159,
    "totalAbsences": 51,
    "totalRetardMinutes": 427,
    "tauxPresence": 75.7
  },
  {
    "nom": "ZAINAB  BAHLO",
    "codeMassar": "F163047989",
    "niveau": "Tronc Commun",
    "totalSessions": 247,
    "totalPresences": 197,
    "totalAbsences": 50,
    "totalRetardMinutes": 330,
    "tauxPresence": 79.8
  },
  {
    "nom": "WISSAL TAIBANE",
    "codeMassar": "R132760116",
    "niveau": "Tronc Commun",
    "totalSessions": 230,
    "totalPresences": 183,
    "totalAbsences": 47,
    "totalRetardMinutes": 65,
    "tauxPresence": 79.6
  },
  {
    "nom": "BAHIJA TAOUJI",
    "codeMassar": "F166088647",
    "niveau": "1BAC SC",
    "totalSessions": 213,
    "totalPresences": 166,
    "totalAbsences": 47,
    "totalRetardMinutes": 40,
    "tauxPresence": 77.9
  },
  {
    "nom": "GHIZLANI IHSSANE",
    "codeMassar": "R131808065",
    "niveau": "2BAC Économie",
    "totalSessions": 212,
    "totalPresences": 166,
    "totalAbsences": 46,
    "totalRetardMinutes": 110,
    "tauxPresence": 78.3
  },
  {
    "nom": "MOHAMMED EZZAHOUANI",
    "codeMassar": "R148183240",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 164,
    "totalAbsences": 46,
    "totalRetardMinutes": 266,
    "tauxPresence": 78.1
  },
  {
    "nom": "OMAR KARIMI",
    "codeMassar": "R133748545",
    "niveau": "2BAC Économie",
    "totalSessions": 169,
    "totalPresences": 124,
    "totalAbsences": 45,
    "totalRetardMinutes": 185,
    "tauxPresence": 73.4
  },
  {
    "nom": "AZHAR ROMAYSSAA",
    "codeMassar": "R156026695",
    "niveau": "2BAC PC",
    "totalSessions": 182,
    "totalPresences": 138,
    "totalAbsences": 44,
    "totalRetardMinutes": 0,
    "tauxPresence": 75.8
  },
  {
    "nom": "NADI IMANE",
    "codeMassar": "R145178715",
    "niveau": "2BAC PC",
    "totalSessions": 226,
    "totalPresences": 183,
    "totalAbsences": 43,
    "totalRetardMinutes": 368,
    "tauxPresence": 81.0
  },
  {
    "nom": "MAHMOUDI MALAK",
    "codeMassar": "F169113409",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 168,
    "totalAbsences": 42,
    "totalRetardMinutes": 122,
    "tauxPresence": 80.0
  },
  {
    "nom": "HAJAR AFIFI",
    "codeMassar": "R151052207",
    "niveau": "2BAC PC",
    "totalSessions": 102,
    "totalPresences": 61,
    "totalAbsences": 41,
    "totalRetardMinutes": 0,
    "tauxPresence": 59.8
  },
  {
    "nom": "ELABBAR MOHAMED RAYAN",
    "codeMassar": "R141158698",
    "niveau": "2BAC Économie",
    "totalSessions": 172,
    "totalPresences": 132,
    "totalAbsences": 40,
    "totalRetardMinutes": 123,
    "tauxPresence": 76.7
  },
  {
    "nom": "AMIR BASSIM",
    "codeMassar": "F191200515",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 185,
    "totalAbsences": 39,
    "totalRetardMinutes": 35,
    "tauxPresence": 82.6
  },
  {
    "nom": "MERIEM MOUNIR",
    "codeMassar": "F160067133",
    "niveau": "1BAC SC",
    "totalSessions": 213,
    "totalPresences": 174,
    "totalAbsences": 39,
    "totalRetardMinutes": 30,
    "tauxPresence": 81.7
  },
  {
    "nom": "DOUAA FARAH",
    "codeMassar": "R142189607",
    "niveau": "2BAC PC",
    "totalSessions": 225,
    "totalPresences": 189,
    "totalAbsences": 36,
    "totalRetardMinutes": 102,
    "tauxPresence": 84.0
  },
  {
    "nom": "AZHAR MOAMIN",
    "codeMassar": "F162144477",
    "niveau": "1BAC Économie",
    "totalSessions": 212,
    "totalPresences": 176,
    "totalAbsences": 36,
    "totalRetardMinutes": 128,
    "tauxPresence": 83.0
  },
  {
    "nom": "KENZA LAMRANI",
    "codeMassar": "R131239442",
    "niveau": "2BAC PC",
    "totalSessions": 215,
    "totalPresences": 180,
    "totalAbsences": 35,
    "totalRetardMinutes": 205,
    "tauxPresence": 83.7
  },
  {
    "nom": "BRHAIDID MOHSSINE",
    "codeMassar": "K154028396",
    "niveau": "2BAC Économie",
    "totalSessions": 169,
    "totalPresences": 134,
    "totalAbsences": 35,
    "totalRetardMinutes": 30,
    "tauxPresence": 79.3
  },
  {
    "nom": "NAHRAWAN BOUTAHARE",
    "codeMassar": "R154053779",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 176,
    "totalAbsences": 34,
    "totalRetardMinutes": 130,
    "tauxPresence": 83.8
  },
  {
    "nom": "ADAM EL MBARKI",
    "codeMassar": "R137910909",
    "niveau": "1BAC Économie",
    "totalSessions": 145,
    "totalPresences": 111,
    "totalAbsences": 34,
    "totalRetardMinutes": 120,
    "tauxPresence": 76.6
  },
  {
    "nom": "KHALID SAMI",
    "codeMassar": "R144168203",
    "niveau": "1BAC Économie",
    "totalSessions": 52,
    "totalPresences": 19,
    "totalAbsences": 33,
    "totalRetardMinutes": 20,
    "tauxPresence": 36.5
  },
  {
    "nom": "DOUHOU WALID",
    "codeMassar": "R155041408",
    "niveau": "2BAC Économie",
    "totalSessions": 180,
    "totalPresences": 147,
    "totalAbsences": 33,
    "totalRetardMinutes": 427,
    "tauxPresence": 81.7
  },
  {
    "nom": "NADA  ABDESSATTAR",
    "codeMassar": "F161057420",
    "niveau": "1BAC SC",
    "totalSessions": 217,
    "totalPresences": 186,
    "totalAbsences": 31,
    "totalRetardMinutes": 5,
    "tauxPresence": 85.7
  },
  {
    "nom": "JABBAR ADAM",
    "codeMassar": "R145136333",
    "niveau": "2BAC Économie",
    "totalSessions": 212,
    "totalPresences": 182,
    "totalAbsences": 30,
    "totalRetardMinutes": 206,
    "tauxPresence": 85.8
  },
  {
    "nom": "BOUMICHI BASMA",
    "codeMassar": "R131820040",
    "niveau": "2BAC Économie",
    "totalSessions": 158,
    "totalPresences": 128,
    "totalAbsences": 30,
    "totalRetardMinutes": 90,
    "tauxPresence": 81.0
  },
  {
    "nom": "AYA FIKAR",
    "codeMassar": "F160027986",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 183,
    "totalAbsences": 29,
    "totalRetardMinutes": 55,
    "tauxPresence": 86.3
  },
  {
    "nom": "IKRAM ETTAJRE",
    "codeMassar": "R152060356",
    "niveau": "2BAC Économie",
    "totalSessions": 157,
    "totalPresences": 128,
    "totalAbsences": 29,
    "totalRetardMinutes": 115,
    "tauxPresence": 81.5
  },
  {
    "nom": "SAAD DAHMI",
    "codeMassar": "R143159072",
    "niveau": "2BAC Économie",
    "totalSessions": 128,
    "totalPresences": 99,
    "totalAbsences": 29,
    "totalRetardMinutes": 170,
    "tauxPresence": 77.3
  },
  {
    "nom": "ASMAE MIDANI",
    "codeMassar": "R151028185",
    "niveau": "Tronc Commun",
    "totalSessions": 232,
    "totalPresences": 203,
    "totalAbsences": 29,
    "totalRetardMinutes": 171,
    "tauxPresence": 87.5
  },
  {
    "nom": "HAZMI KENZA",
    "codeMassar": "F164075587",
    "niveau": "1BAC Économie",
    "totalSessions": 213,
    "totalPresences": 184,
    "totalAbsences": 29,
    "totalRetardMinutes": 205,
    "tauxPresence": 86.4
  },
  {
    "nom": "HAKKAOUI KHOULOUD",
    "codeMassar": "R149133850",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 190,
    "totalAbsences": 28,
    "totalRetardMinutes": 125,
    "tauxPresence": 87.2
  },
  {
    "nom": "MARMOUCHA MOSTAPHA",
    "codeMassar": "R142197104",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 218,
    "totalAbsences": 28,
    "totalRetardMinutes": 96,
    "tauxPresence": 88.6
  },
  {
    "nom": "MALAK ER-REFDY",
    "codeMassar": "F226208237",
    "niveau": "2BAC Économie",
    "totalSessions": 185,
    "totalPresences": 158,
    "totalAbsences": 27,
    "totalRetardMinutes": 75,
    "tauxPresence": 85.4
  },
  {
    "nom": "MAZI ADAM",
    "codeMassar": "F168131439",
    "niveau": "1BAC Économie",
    "totalSessions": 160,
    "totalPresences": 133,
    "totalAbsences": 27,
    "totalRetardMinutes": 80,
    "tauxPresence": 83.1
  },
  {
    "nom": "HANOUNE GHITA",
    "codeMassar": "R152054752",
    "niveau": "2BAC PC",
    "totalSessions": 173,
    "totalPresences": 147,
    "totalAbsences": 26,
    "totalRetardMinutes": 0,
    "tauxPresence": 85.0
  },
  {
    "nom": "YASSER IBRAHIM RAFAKI",
    "codeMassar": "R156077254",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 184,
    "totalAbsences": 26,
    "totalRetardMinutes": 0,
    "tauxPresence": 87.6
  },
  {
    "nom": "CHAKIRI IHSSANE",
    "codeMassar": "F177069204",
    "niveau": "Tronc Commun",
    "totalSessions": 127,
    "totalPresences": 101,
    "totalAbsences": 26,
    "totalRetardMinutes": 30,
    "tauxPresence": 79.5
  },
  {
    "nom": "DOUNIA BABA",
    "codeMassar": "F167025648",
    "niveau": "1BAC Économie",
    "totalSessions": 217,
    "totalPresences": 192,
    "totalAbsences": 25,
    "totalRetardMinutes": 0,
    "tauxPresence": 88.5
  },
  {
    "nom": "NAHLA RAOUI",
    "codeMassar": "R136770871",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 156,
    "totalAbsences": 25,
    "totalRetardMinutes": 304,
    "tauxPresence": 86.2
  },
  {
    "nom": "ELHAFIDI IMANE",
    "codeMassar": "R135456628",
    "niveau": "2BAC PC",
    "totalSessions": 211,
    "totalPresences": 186,
    "totalAbsences": 25,
    "totalRetardMinutes": 50,
    "tauxPresence": 88.2
  },
  {
    "nom": "HAITAM CHANE",
    "codeMassar": "F168086197",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 219,
    "totalAbsences": 25,
    "totalRetardMinutes": 111,
    "tauxPresence": 89.8
  },
  {
    "nom": "HOUSSAM BRHAIDID",
    "codeMassar": "K154028404",
    "niveau": "2BAC PC",
    "totalSessions": 181,
    "totalPresences": 156,
    "totalAbsences": 25,
    "totalRetardMinutes": 0,
    "tauxPresence": 86.2
  },
  {
    "nom": "BADREDDINE FASSIH",
    "codeMassar": "R150001407",
    "niveau": "1BAC Économie",
    "totalSessions": 156,
    "totalPresences": 132,
    "totalAbsences": 24,
    "totalRetardMinutes": 353,
    "tauxPresence": 84.6
  },
  {
    "nom": "MOHAMMED AMINE DARIF",
    "codeMassar": "F160091022",
    "niveau": "1BAC Économie",
    "totalSessions": 200,
    "totalPresences": 176,
    "totalAbsences": 24,
    "totalRetardMinutes": 0,
    "tauxPresence": 88.0
  },
  {
    "nom": "AICHA RAOUI",
    "codeMassar": "R139770881",
    "niveau": "2BAC PC",
    "totalSessions": 188,
    "totalPresences": 164,
    "totalAbsences": 24,
    "totalRetardMinutes": 280,
    "tauxPresence": 87.2
  },
  {
    "nom": "FIKAR MOHAMED",
    "codeMassar": "R149168220",
    "niveau": "2BAC Économie",
    "totalSessions": 212,
    "totalPresences": 188,
    "totalAbsences": 24,
    "totalRetardMinutes": 85,
    "tauxPresence": 88.7
  },
  {
    "nom": "HSAINE DINA",
    "codeMassar": "F171005418",
    "niveau": "Tronc Commun",
    "totalSessions": 157,
    "totalPresences": 133,
    "totalAbsences": 24,
    "totalRetardMinutes": 45,
    "tauxPresence": 84.7
  },
  {
    "nom": "MASSIKI SAAD",
    "codeMassar": "R149159702",
    "niveau": "2BAC Économie",
    "totalSessions": 199,
    "totalPresences": 176,
    "totalAbsences": 23,
    "totalRetardMinutes": 90,
    "tauxPresence": 88.4
  },
  {
    "nom": "DIKRA AMMARI",
    "codeMassar": "F162057121",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 195,
    "totalAbsences": 23,
    "totalRetardMinutes": 71,
    "tauxPresence": 89.4
  },
  {
    "nom": "SAFAA FARHANE",
    "codeMassar": "R130902679",
    "niveau": "1BAC Économie",
    "totalSessions": 102,
    "totalPresences": 79,
    "totalAbsences": 23,
    "totalRetardMinutes": 20,
    "tauxPresence": 77.5
  },
  {
    "nom": "MOHAMED ALI ELKOUNTI",
    "codeMassar": "F180070827",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 196,
    "totalAbsences": 23,
    "totalRetardMinutes": 110,
    "tauxPresence": 89.5
  },
  {
    "nom": "NAWFAL FIDIA",
    "codeMassar": "F185130487",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 196,
    "totalAbsences": 23,
    "totalRetardMinutes": 0,
    "tauxPresence": 89.5
  },
  {
    "nom": "SAAD HAMMIDDINE",
    "codeMassar": "F179231483",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 203,
    "totalAbsences": 22,
    "totalRetardMinutes": 0,
    "tauxPresence": 90.2
  },
  {
    "nom": "HOUD ISLAM FAKHER",
    "codeMassar": "F174161765",
    "niveau": "Tronc Commun",
    "totalSessions": 127,
    "totalPresences": 105,
    "totalAbsences": 22,
    "totalRetardMinutes": 212,
    "tauxPresence": 82.7
  },
  {
    "nom": "ISMAIL OURAHMA",
    "codeMassar": "F160080107",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 223,
    "totalAbsences": 21,
    "totalRetardMinutes": 101,
    "tauxPresence": 91.4
  },
  {
    "nom": "AYA CHOUAIBI",
    "codeMassar": "R149164844",
    "niveau": "1BAC SC",
    "totalSessions": 80,
    "totalPresences": 59,
    "totalAbsences": 21,
    "totalRetardMinutes": 15,
    "tauxPresence": 73.8
  },
  {
    "nom": "AZI RAYANE",
    "codeMassar": "R139618241",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 160,
    "totalAbsences": 21,
    "totalRetardMinutes": 15,
    "tauxPresence": 88.4
  },
  {
    "nom": "RACHA KAISSY",
    "codeMassar": "R155052188",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 160,
    "totalAbsences": 21,
    "totalRetardMinutes": 25,
    "tauxPresence": 88.4
  },
  {
    "nom": "ZAAM MOHAMMED RAYANE",
    "codeMassar": "R161000580",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 190,
    "totalAbsences": 20,
    "totalRetardMinutes": 15,
    "tauxPresence": 90.5
  },
  {
    "nom": "ZAKARIA HDIDDOU",
    "codeMassar": "R146194541",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 161,
    "totalAbsences": 20,
    "totalRetardMinutes": 95,
    "tauxPresence": 89.0
  },
  {
    "nom": "BILAL ANDAM",
    "codeMassar": "R159029787",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 192,
    "totalAbsences": 20,
    "totalRetardMinutes": 0,
    "tauxPresence": 90.6
  },
  {
    "nom": "SAJID HAFSA",
    "codeMassar": "R144177241",
    "niveau": "2BAC Économie",
    "totalSessions": 165,
    "totalPresences": 145,
    "totalAbsences": 20,
    "totalRetardMinutes": 0,
    "tauxPresence": 87.9
  },
  {
    "nom": "NOURHANE DEBBAGH",
    "codeMassar": "F162003259",
    "niveau": "1BAC Économie",
    "totalSessions": 212,
    "totalPresences": 192,
    "totalAbsences": 20,
    "totalRetardMinutes": 267,
    "tauxPresence": 90.6
  },
  {
    "nom": "FATIMA ZAHRA ELMOUKRI",
    "codeMassar": "R144198924",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 196,
    "totalAbsences": 20,
    "totalRetardMinutes": 70,
    "tauxPresence": 90.7
  },
  {
    "nom": "ELABBAR FATIMA ZAHRA",
    "codeMassar": "R132799060",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 197,
    "totalAbsences": 19,
    "totalRetardMinutes": 290,
    "tauxPresence": 91.2
  },
  {
    "nom": "ISSLAM HARF",
    "codeMassar": "F169058677",
    "niveau": "1BAC SC",
    "totalSessions": 211,
    "totalPresences": 192,
    "totalAbsences": 19,
    "totalRetardMinutes": 85,
    "tauxPresence": 91.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 31,
    "totalPresences": 12,
    "totalAbsences": 19,
    "totalRetardMinutes": 0,
    "tauxPresence": 38.7
  },
  {
    "nom": "MOHAMED WALID  MARGA",
    "codeMassar": "R156048992",
    "niveau": "2BAC PC",
    "totalSessions": 173,
    "totalPresences": 154,
    "totalAbsences": 19,
    "totalRetardMinutes": 30,
    "tauxPresence": 89.0
  },
  {
    "nom": "JINANE LA KHLIFI",
    "codeMassar": "F162057400",
    "niveau": "1BAC SC",
    "totalSessions": 196,
    "totalPresences": 177,
    "totalAbsences": 19,
    "totalRetardMinutes": 75,
    "tauxPresence": 90.3
  },
  {
    "nom": "ALAE JAKMI",
    "codeMassar": "R142190061",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 185,
    "totalAbsences": 18,
    "totalRetardMinutes": 45,
    "tauxPresence": 91.1
  },
  {
    "nom": "DOUAA OUAOURIR",
    "codeMassar": "R148183500",
    "niveau": "2BAC PC",
    "totalSessions": 208,
    "totalPresences": 190,
    "totalAbsences": 18,
    "totalRetardMinutes": 75,
    "tauxPresence": 91.3
  },
  {
    "nom": "MOHAMED AMINE  AL DAHBI",
    "codeMassar": "F194074081",
    "niveau": "2AC",
    "totalSessions": 222,
    "totalPresences": 204,
    "totalAbsences": 18,
    "totalRetardMinutes": 15,
    "tauxPresence": 91.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 34,
    "totalPresences": 16,
    "totalAbsences": 18,
    "totalRetardMinutes": 0,
    "tauxPresence": 47.1
  },
  {
    "nom": "WIAM ALI SABRI",
    "codeMassar": "R141154946",
    "niveau": "1BAC SC",
    "totalSessions": 214,
    "totalPresences": 196,
    "totalAbsences": 18,
    "totalRetardMinutes": 65,
    "tauxPresence": 91.6
  },
  {
    "nom": "HAYTAM HARRAT",
    "codeMassar": "R153052635",
    "niveau": "1BAC SC",
    "totalSessions": 213,
    "totalPresences": 195,
    "totalAbsences": 18,
    "totalRetardMinutes": 97,
    "tauxPresence": 91.5
  },
  {
    "nom": "ASSIA BOUSSALEM",
    "codeMassar": "F259148553",
    "niveau": "2BAC PC",
    "totalSessions": 169,
    "totalPresences": 151,
    "totalAbsences": 18,
    "totalRetardMinutes": 30,
    "tauxPresence": 89.3
  },
  {
    "nom": "MOHAMMED AMINE BENTAZI",
    "codeMassar": "F179180020",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 229,
    "totalAbsences": 17,
    "totalRetardMinutes": 130,
    "tauxPresence": 93.1
  },
  {
    "nom": "AMINE FKIRA",
    "codeMassar": "R145123979",
    "niveau": "2BAC Économie",
    "totalSessions": 159,
    "totalPresences": 142,
    "totalAbsences": 17,
    "totalRetardMinutes": 45,
    "tauxPresence": 89.3
  },
  {
    "nom": "SALMA ELOUARDI",
    "codeMassar": "R145167976",
    "niveau": "2BAC PC",
    "totalSessions": 222,
    "totalPresences": 205,
    "totalAbsences": 17,
    "totalRetardMinutes": 15,
    "tauxPresence": 92.3
  },
  {
    "nom": "ZAYD MOUFKI",
    "codeMassar": "F195216879",
    "niveau": "2AC",
    "totalSessions": 226,
    "totalPresences": 210,
    "totalAbsences": 16,
    "totalRetardMinutes": 35,
    "tauxPresence": 92.9
  },
  {
    "nom": "FARRAKH SARA",
    "codeMassar": "R134760106",
    "niveau": "2BAC PC",
    "totalSessions": 200,
    "totalPresences": 184,
    "totalAbsences": 16,
    "totalRetardMinutes": 65,
    "tauxPresence": 92.0
  },
  {
    "nom": "ADAM AAMAR",
    "codeMassar": "F165060063",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 194,
    "totalAbsences": 16,
    "totalRetardMinutes": 150,
    "tauxPresence": 92.4
  },
  {
    "nom": "AINANE RAYANE",
    "codeMassar": "R135817065",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 187,
    "totalAbsences": 16,
    "totalRetardMinutes": 40,
    "tauxPresence": 92.1
  },
  {
    "nom": "ABDELAZIZ LMRAZKI",
    "codeMassar": "F164088809",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 202,
    "totalAbsences": 16,
    "totalRetardMinutes": 0,
    "tauxPresence": 92.7
  },
  {
    "nom": "MED REDA AFIFI",
    "codeMassar": "F193034370",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 209,
    "totalAbsences": 16,
    "totalRetardMinutes": 0,
    "tauxPresence": 92.9
  },
  {
    "nom": "AYA SAIDI",
    "codeMassar": "F160094068",
    "niveau": "1BAC Économie",
    "totalSessions": 184,
    "totalPresences": 168,
    "totalAbsences": 16,
    "totalRetardMinutes": 249,
    "tauxPresence": 91.3
  },
  {
    "nom": "MOHAMED AMINE YAKINE",
    "codeMassar": "F161136205",
    "niveau": "1BAC Économie",
    "totalSessions": 215,
    "totalPresences": 199,
    "totalAbsences": 16,
    "totalRetardMinutes": 200,
    "tauxPresence": 92.6
  },
  {
    "nom": "BASSMA SABIR",
    "codeMassar": "F197147014",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 210,
    "totalAbsences": 15,
    "totalRetardMinutes": 55,
    "tauxPresence": 93.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 30,
    "totalPresences": 15,
    "totalAbsences": 15,
    "totalRetardMinutes": 4,
    "tauxPresence": 50.0
  },
  {
    "nom": "ABDELLAH BAKOURI",
    "codeMassar": "R157045866",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 231,
    "totalAbsences": 15,
    "totalRetardMinutes": 250,
    "tauxPresence": 93.9
  },
  {
    "nom": "HAMZA MOUTASSADIQ",
    "codeMassar": "R146159752",
    "niveau": "2BAC Économie",
    "totalSessions": 215,
    "totalPresences": 200,
    "totalAbsences": 15,
    "totalRetardMinutes": 271,
    "tauxPresence": 93.0
  },
  {
    "nom": "NIHAD EL KHARROUBI",
    "codeMassar": "R142205251",
    "niveau": "2BAC PC",
    "totalSessions": 112,
    "totalPresences": 97,
    "totalAbsences": 15,
    "totalRetardMinutes": 15,
    "tauxPresence": 86.6
  },
  {
    "nom": "ANWAR ABDESSETTAR",
    "codeMassar": "F178034731",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 205,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 93.6
  },
  {
    "nom": "SARA FARTAT",
    "codeMassar": "R143196528",
    "niveau": "2BAC PC",
    "totalSessions": 220,
    "totalPresences": 206,
    "totalAbsences": 14,
    "totalRetardMinutes": 155,
    "tauxPresence": 93.6
  },
  {
    "nom": "WIAM SABER",
    "codeMassar": "F174150715",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 230,
    "totalAbsences": 14,
    "totalRetardMinutes": 175,
    "tauxPresence": 94.3
  },
  {
    "nom": "ADAM MONSIF",
    "codeMassar": "F164124297",
    "niveau": "1BAC SC",
    "totalSessions": 219,
    "totalPresences": 205,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 93.6
  },
  {
    "nom": "MARYAM ALAOUI HIJAZI",
    "codeMassar": "R140159542",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 204,
    "totalAbsences": 14,
    "totalRetardMinutes": 15,
    "tauxPresence": 93.6
  },
  {
    "nom": "AYOUB HASSIB",
    "codeMassar": "R154001429",
    "niveau": "Tronc Commun",
    "totalSessions": 102,
    "totalPresences": 88,
    "totalAbsences": 14,
    "totalRetardMinutes": 45,
    "tauxPresence": 86.3
  },
  {
    "nom": "MOHAMMED NIZAR MARGA",
    "codeMassar": "F196076169",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 211,
    "totalAbsences": 14,
    "totalRetardMinutes": 20,
    "tauxPresence": 93.8
  },
  {
    "nom": "ZIAD ACHAHOU",
    "codeMassar": "F172179964",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 230,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 94.3
  },
  {
    "nom": "SOFIA HOUKMELLAH",
    "codeMassar": "R134738509",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 198,
    "totalAbsences": 14,
    "totalRetardMinutes": 15,
    "tauxPresence": 93.4
  },
  {
    "nom": "BOUTLANE MARWA",
    "codeMassar": "R178245100",
    "niveau": "3AC",
    "totalSessions": 205,
    "totalPresences": 191,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 93.2
  },
  {
    "nom": "MOHAMMED ADAM ELHAMDAOUI",
    "codeMassar": "F172202344",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 232,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 94.3
  },
  {
    "nom": "AQUIL YOUSRA",
    "codeMassar": "R131834353",
    "niveau": "2BAC Économie",
    "totalSessions": 187,
    "totalPresences": 173,
    "totalAbsences": 14,
    "totalRetardMinutes": 0,
    "tauxPresence": 92.5
  },
  {
    "nom": "SIRINE ELASRAOUI",
    "codeMassar": "R146199996",
    "niveau": "2BAC Économie",
    "totalSessions": 207,
    "totalPresences": 193,
    "totalAbsences": 14,
    "totalRetardMinutes": 110,
    "tauxPresence": 93.2
  },
  {
    "nom": "FATIMA ZAHRA  AL MFADDEL",
    "codeMassar": "F168117798",
    "niveau": "1BAC Économie",
    "totalSessions": 214,
    "totalPresences": 201,
    "totalAbsences": 13,
    "totalRetardMinutes": 15,
    "tauxPresence": 93.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 37,
    "totalPresences": 24,
    "totalAbsences": 13,
    "totalRetardMinutes": 7,
    "tauxPresence": 64.9
  },
  {
    "nom": "YAHYA MOUTAABBID",
    "codeMassar": "F160137919",
    "niveau": "1BAC SC",
    "totalSessions": 213,
    "totalPresences": 200,
    "totalAbsences": 13,
    "totalRetardMinutes": 140,
    "tauxPresence": 93.9
  },
  {
    "nom": "RIHAN NACHAT",
    "codeMassar": "F164111888",
    "niveau": "1BAC SC",
    "totalSessions": 215,
    "totalPresences": 202,
    "totalAbsences": 13,
    "totalRetardMinutes": 45,
    "tauxPresence": 94.0
  },
  {
    "nom": "YOUSSEF MAROUF",
    "codeMassar": "F172122870",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 232,
    "totalAbsences": 12,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.1
  },
  {
    "nom": "MOUWAHED DOUAA",
    "codeMassar": "R154050720",
    "niveau": "2BAC Économie",
    "totalSessions": 159,
    "totalPresences": 147,
    "totalAbsences": 12,
    "totalRetardMinutes": 165,
    "tauxPresence": 92.5
  },
  {
    "nom": "AYMEN RAOUI",
    "codeMassar": "F164128191",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 201,
    "totalAbsences": 11,
    "totalRetardMinutes": 0,
    "tauxPresence": 94.8
  },
  {
    "nom": "NOUKRI SAAD ALLAH",
    "codeMassar": "F160089046",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 233,
    "totalAbsences": 11,
    "totalRetardMinutes": 71,
    "tauxPresence": 95.5
  },
  {
    "nom": "BELGRRAB BAHAE-DDINE",
    "codeMassar": "F161143020",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 232,
    "totalAbsences": 11,
    "totalRetardMinutes": 139,
    "tauxPresence": 95.5
  },
  {
    "nom": "AMINA LAHBIB",
    "codeMassar": "F161052048",
    "niveau": "1BAC Économie",
    "totalSessions": 216,
    "totalPresences": 205,
    "totalAbsences": 11,
    "totalRetardMinutes": 35,
    "tauxPresence": 94.9
  },
  {
    "nom": "SALEK SAAD",
    "codeMassar": "R152069448",
    "niveau": "2BAC PC",
    "totalSessions": 140,
    "totalPresences": 129,
    "totalAbsences": 11,
    "totalRetardMinutes": 45,
    "tauxPresence": 92.1
  },
  {
    "nom": "AYA ZEROUAL",
    "codeMassar": "F166089626",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 201,
    "totalAbsences": 11,
    "totalRetardMinutes": 0,
    "tauxPresence": 94.8
  },
  {
    "nom": "RIM HANOUNE",
    "codeMassar": "F161136201",
    "niveau": "3AC",
    "totalSessions": 218,
    "totalPresences": 207,
    "totalAbsences": 11,
    "totalRetardMinutes": 30,
    "tauxPresence": 95.0
  },
  {
    "nom": "MALAK GHALIM",
    "codeMassar": "R156073220",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 170,
    "totalAbsences": 11,
    "totalRetardMinutes": 15,
    "tauxPresence": 93.9
  },
  {
    "nom": "DOUAA EL MSAADI",
    "codeMassar": "R130879709",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 179,
    "totalAbsences": 11,
    "totalRetardMinutes": 235,
    "tauxPresence": 94.2
  },
  {
    "nom": "ZYAT MALAK",
    "codeMassar": "R135788179",
    "niveau": "2BAC Économie",
    "totalSessions": 166,
    "totalPresences": 155,
    "totalAbsences": 11,
    "totalRetardMinutes": 30,
    "tauxPresence": 93.4
  },
  {
    "nom": "SARA CHAGDALI",
    "codeMassar": "F185000621",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 236,
    "totalAbsences": 10,
    "totalRetardMinutes": 15,
    "tauxPresence": 95.9
  },
  {
    "nom": "BENSAGHIR YAHYA",
    "codeMassar": "F171069146",
    "niveau": "3AC",
    "totalSessions": 117,
    "totalPresences": 107,
    "totalAbsences": 10,
    "totalRetardMinutes": 15,
    "tauxPresence": 91.5
  },
  {
    "nom": "LAMSALHI YASSMINE",
    "codeMassar": "R144180337",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 208,
    "totalAbsences": 10,
    "totalRetardMinutes": 65,
    "tauxPresence": 95.4
  },
  {
    "nom": "HIBATALLAH EL KHEIR",
    "codeMassar": "R143165020",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 177,
    "totalAbsences": 10,
    "totalRetardMinutes": 275,
    "tauxPresence": 94.7
  },
  {
    "nom": "AYA MERKAZI",
    "codeMassar": "R145166515",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 206,
    "totalAbsences": 10,
    "totalRetardMinutes": 58,
    "tauxPresence": 95.4
  },
  {
    "nom": "KHALIL SABAH",
    "codeMassar": "F174209901",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 213,
    "totalAbsences": 10,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.5
  },
  {
    "nom": "ADAM BOUSSALAH",
    "codeMassar": "R132788334",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 171,
    "totalAbsences": 10,
    "totalRetardMinutes": 15,
    "tauxPresence": 94.5
  },
  {
    "nom": "RAYANE BOUTLANE",
    "codeMassar": "R149132348",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 213,
    "totalAbsences": 10,
    "totalRetardMinutes": 30,
    "tauxPresence": 95.5
  },
  {
    "nom": "CHIC RANIA",
    "codeMassar": "R157048168",
    "niveau": "2BAC PC",
    "totalSessions": 167,
    "totalPresences": 157,
    "totalAbsences": 10,
    "totalRetardMinutes": 125,
    "tauxPresence": 94.0
  },
  {
    "nom": "AYOUB MERKAZI",
    "codeMassar": "R157059713",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 177,
    "totalAbsences": 10,
    "totalRetardMinutes": 52,
    "tauxPresence": 94.7
  },
  {
    "nom": "HAMMAM MANHI",
    "codeMassar": "F185205434",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 209,
    "totalAbsences": 10,
    "totalRetardMinutes": 5,
    "tauxPresence": 95.4
  },
  {
    "nom": "RAYANE ZIZI",
    "codeMassar": "F182171714",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 209,
    "totalAbsences": 10,
    "totalRetardMinutes": 15,
    "tauxPresence": 95.4
  },
  {
    "nom": "AYOUB MAROUF",
    "codeMassar": "F194017912",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 213,
    "totalAbsences": 10,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.5
  },
  {
    "nom": "RAYANE HOUSNI",
    "codeMassar": "R148153782",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 214,
    "totalAbsences": 9,
    "totalRetardMinutes": 195,
    "tauxPresence": 96.0
  },
  {
    "nom": "NADA ASSOU",
    "codeMassar": "F170184458",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 237,
    "totalAbsences": 9,
    "totalRetardMinutes": 95,
    "tauxPresence": 96.3
  },
  {
    "nom": "ADNANE SAIH",
    "codeMassar": "F183140692",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 215,
    "totalAbsences": 9,
    "totalRetardMinutes": 40,
    "tauxPresence": 96.0
  },
  {
    "nom": "NIAMA CHAOUKI",
    "codeMassar": "F161096389",
    "niveau": "1BAC Économie",
    "totalSessions": 214,
    "totalPresences": 205,
    "totalAbsences": 9,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.8
  },
  {
    "nom": "MOHAMMED REDA MOUTKI",
    "codeMassar": "F182141242",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 210,
    "totalAbsences": 9,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 17,
    "totalPresences": 8,
    "totalAbsences": 9,
    "totalRetardMinutes": 0,
    "tauxPresence": 47.1
  },
  {
    "nom": "WIAM SEFIANE",
    "codeMassar": "R156073670",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 172,
    "totalAbsences": 9,
    "totalRetardMinutes": 30,
    "tauxPresence": 95.0
  },
  {
    "nom": "AYOUB HIDRA",
    "codeMassar": "R139267636",
    "niveau": "2BAC PC",
    "totalSessions": 218,
    "totalPresences": 209,
    "totalAbsences": 9,
    "totalRetardMinutes": 15,
    "tauxPresence": 95.9
  },
  {
    "nom": "ABDESSALAM DRAISS",
    "codeMassar": "F178224247",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 210,
    "totalAbsences": 9,
    "totalRetardMinutes": 100,
    "tauxPresence": 95.9
  },
  {
    "nom": "HIBA MAANAOUI",
    "codeMassar": "K135476822",
    "niveau": "2BAC PC",
    "totalSessions": 220,
    "totalPresences": 211,
    "totalAbsences": 9,
    "totalRetardMinutes": 15,
    "tauxPresence": 95.9
  },
  {
    "nom": "SALMA ELHAYAT",
    "codeMassar": "R140152536",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 181,
    "totalAbsences": 9,
    "totalRetardMinutes": 130,
    "tauxPresence": 95.3
  },
  {
    "nom": "HIBA ELMEHDY",
    "codeMassar": "F163102966",
    "niveau": "Tronc Commun",
    "totalSessions": 233,
    "totalPresences": 224,
    "totalAbsences": 9,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.1
  },
  {
    "nom": "ZINEB HANNACH",
    "codeMassar": "R131206344",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 214,
    "totalAbsences": 9,
    "totalRetardMinutes": 82,
    "tauxPresence": 96.0
  },
  {
    "nom": "ROUDAYNA HAMDANI",
    "codeMassar": "F177164005",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 235,
    "totalAbsences": 9,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.3
  },
  {
    "nom": "ABDESSAMAD SABAR",
    "codeMassar": "R136776368",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 214,
    "totalAbsences": 9,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.0
  },
  {
    "nom": "ZAYD SBAI",
    "codeMassar": "F168008324",
    "niveau": "1BAC SC",
    "totalSessions": 217,
    "totalPresences": 208,
    "totalAbsences": 9,
    "totalRetardMinutes": 0,
    "tauxPresence": 95.9
  },
  {
    "nom": "ALAE LIBANE",
    "codeMassar": "F174089443",
    "niveau": "Tronc Commun",
    "totalSessions": 242,
    "totalPresences": 233,
    "totalAbsences": 9,
    "totalRetardMinutes": 60,
    "tauxPresence": 96.3
  },
  {
    "nom": "AYA ELMGHARI",
    "codeMassar": "F166092115",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 211,
    "totalAbsences": 8,
    "totalRetardMinutes": 50,
    "tauxPresence": 96.3
  },
  {
    "nom": "MOHAMED EL  BACHIR MAJDOUBI",
    "codeMassar": "F173194828",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 211,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.3
  },
  {
    "nom": "ZIAD FARHANE",
    "codeMassar": "F171234275",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 238,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.7
  },
  {
    "nom": "INES SAFAR",
    "codeMassar": "R141194506",
    "niveau": "2BAC Économie",
    "totalSessions": 179,
    "totalPresences": 171,
    "totalAbsences": 8,
    "totalRetardMinutes": 15,
    "tauxPresence": 95.5
  },
  {
    "nom": "MOHAMED AMINE ASSAB",
    "codeMassar": "R154071342",
    "niveau": "2BAC Économie",
    "totalSessions": 182,
    "totalPresences": 174,
    "totalAbsences": 8,
    "totalRetardMinutes": 55,
    "tauxPresence": 95.6
  },
  {
    "nom": "TAHA EL KAMLI",
    "codeMassar": "F191017920",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 217,
    "totalAbsences": 8,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.4
  },
  {
    "nom": "LAAJILI MOHAMMED",
    "codeMassar": "R142205247",
    "niveau": "2BAC PC",
    "totalSessions": 110,
    "totalPresences": 102,
    "totalAbsences": 8,
    "totalRetardMinutes": 15,
    "tauxPresence": 92.7
  },
  {
    "nom": "KHOULOUD BOUSSALAH",
    "codeMassar": "F169066533",
    "niveau": "1BAC SC",
    "totalSessions": 216,
    "totalPresences": 208,
    "totalAbsences": 8,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.3
  },
  {
    "nom": "BASMA LAKRAFI",
    "codeMassar": "R155042569",
    "niveau": "2BAC PC",
    "totalSessions": 171,
    "totalPresences": 163,
    "totalAbsences": 8,
    "totalRetardMinutes": 250,
    "tauxPresence": 95.3
  },
  {
    "nom": "ELAIDI MOHAMED AMINE",
    "codeMassar": "R136774226",
    "niveau": "2BAC Économie",
    "totalSessions": 207,
    "totalPresences": 199,
    "totalAbsences": 8,
    "totalRetardMinutes": 130,
    "tauxPresence": 96.1
  },
  {
    "nom": "HIBATALLAH MOUTAKI",
    "codeMassar": "R148155780",
    "niveau": "2BAC PC",
    "totalSessions": 221,
    "totalPresences": 213,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.4
  },
  {
    "nom": "SOUFIANE LAGUEDANI",
    "codeMassar": "R145178098",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 202,
    "totalAbsences": 8,
    "totalRetardMinutes": 270,
    "tauxPresence": 96.2
  },
  {
    "nom": "MOHAMED RAYANE ASKARI",
    "codeMassar": "F178056331",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 236,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.7
  },
  {
    "nom": "WAFA BAHIDA",
    "codeMassar": "R143178480",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 191,
    "totalAbsences": 8,
    "totalRetardMinutes": 70,
    "tauxPresence": 96.0
  },
  {
    "nom": "KARIMA EL ALAOUI",
    "codeMassar": "R141191120",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 210,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 8,
    "totalPresences": 0,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "OUSSAID GLAIBI",
    "codeMassar": "F196223406",
    "niveau": "2AC",
    "totalSessions": 227,
    "totalPresences": 219,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.5
  },
  {
    "nom": "NIZAR LABNI",
    "codeMassar": "F161136202",
    "niveau": "1BAC Économie",
    "totalSessions": 213,
    "totalPresences": 205,
    "totalAbsences": 8,
    "totalRetardMinutes": 55,
    "tauxPresence": 96.2
  },
  {
    "nom": "FATIMA ZAHRA HAIE",
    "codeMassar": "F167079119",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 238,
    "totalAbsences": 8,
    "totalRetardMinutes": 105,
    "tauxPresence": 96.7
  },
  {
    "nom": "HAKIKI MOHAMED AMINE",
    "codeMassar": "R157047364",
    "niveau": "1BAC Économie",
    "totalSessions": 211,
    "totalPresences": 203,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.2
  },
  {
    "nom": "MARWA CHEHAH",
    "codeMassar": "R149164500",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 210,
    "totalAbsences": 8,
    "totalRetardMinutes": 20,
    "tauxPresence": 96.3
  },
  {
    "nom": "DOUAA HAFIR",
    "codeMassar": "R152063082",
    "niveau": "1BAC SC",
    "totalSessions": 32,
    "totalPresences": 24,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 75.0
  },
  {
    "nom": "CHAIMAA MAKMOUL",
    "codeMassar": "R141183490",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 191,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.0
  },
  {
    "nom": "OUMAIMA BENHAMOU",
    "codeMassar": "R144165828",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 208,
    "totalAbsences": 8,
    "totalRetardMinutes": 125,
    "tauxPresence": 96.3
  },
  {
    "nom": "IMRANE HAMDOUNE",
    "codeMassar": "F170034840",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 211,
    "totalAbsences": 8,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.3
  },
  {
    "nom": "MOHAMED NEGGAG",
    "codeMassar": "R152031782",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 179,
    "totalAbsences": 8,
    "totalRetardMinutes": 45,
    "tauxPresence": 95.7
  },
  {
    "nom": "SALMANE METLAOUI",
    "codeMassar": "F170035011",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 239,
    "totalAbsences": 7,
    "totalRetardMinutes": 80,
    "tauxPresence": 97.2
  },
  {
    "nom": "ADAM TAIB",
    "codeMassar": "R141162701",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 195,
    "totalAbsences": 7,
    "totalRetardMinutes": 145,
    "tauxPresence": 96.5
  },
  {
    "nom": "MOHAMED AMINE EL KOUNSSI",
    "codeMassar": "R136774159",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 180,
    "totalAbsences": 7,
    "totalRetardMinutes": 135,
    "tauxPresence": 96.3
  },
  {
    "nom": "RIAD ELOTHMANI",
    "codeMassar": "R141160271",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 174,
    "totalAbsences": 7,
    "totalRetardMinutes": 75,
    "tauxPresence": 96.1
  },
  {
    "nom": "HADDOUMI JOMANA",
    "codeMassar": "R152062737",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 174,
    "totalAbsences": 7,
    "totalRetardMinutes": 45,
    "tauxPresence": 96.1
  },
  {
    "nom": "MOUSTAIQUID MAROUA",
    "codeMassar": "R141191856",
    "niveau": "2BAC PC",
    "totalSessions": 226,
    "totalPresences": 219,
    "totalAbsences": 7,
    "totalRetardMinutes": 72,
    "tauxPresence": 96.9
  },
  {
    "nom": "MOHAMMED NABIL FTIAH",
    "codeMassar": "R156060737",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 183,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.3
  },
  {
    "nom": "RAYANE AZHAR",
    "codeMassar": "R136866367",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 192,
    "totalAbsences": 7,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.5
  },
  {
    "nom": "MOSTAPHA MAHBOUB",
    "codeMassar": "F164116285",
    "niveau": "1BAC Économie",
    "totalSessions": 211,
    "totalPresences": 204,
    "totalAbsences": 7,
    "totalRetardMinutes": 40,
    "tauxPresence": 96.7
  },
  {
    "nom": "EL HAIDY AHMED",
    "codeMassar": "R147200011",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 209,
    "totalAbsences": 7,
    "totalRetardMinutes": 135,
    "tauxPresence": 96.8
  },
  {
    "nom": "GLAIBI RODAYNA",
    "codeMassar": "F180123329",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 212,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.8
  },
  {
    "nom": "EL ABBASSI FATIMA ZAHRA",
    "codeMassar": "F172170728",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 236,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.1
  },
  {
    "nom": "AMINE OULHOUSSAINE",
    "codeMassar": "F189079050",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 217,
    "totalAbsences": 7,
    "totalRetardMinutes": 60,
    "tauxPresence": 96.9
  },
  {
    "nom": "SARA EL ACHAARI",
    "codeMassar": "R157072724",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 180,
    "totalAbsences": 7,
    "totalRetardMinutes": 90,
    "tauxPresence": 96.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 24,
    "totalPresences": 17,
    "totalAbsences": 7,
    "totalRetardMinutes": 0,
    "tauxPresence": 70.8
  },
  {
    "nom": "SIRINE TIHADI",
    "codeMassar": "R152044793",
    "niveau": "2BAC PC",
    "totalSessions": 189,
    "totalPresences": 182,
    "totalAbsences": 7,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.3
  },
  {
    "nom": "FERDAOUS BAHANI",
    "codeMassar": "F185096483",
    "niveau": "3AC",
    "totalSessions": 106,
    "totalPresences": 99,
    "totalAbsences": 7,
    "totalRetardMinutes": 5,
    "tauxPresence": 93.4
  },
  {
    "nom": "RIHAM BZIR",
    "codeMassar": "R140153327",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 195,
    "totalAbsences": 7,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.5
  },
  {
    "nom": "WASSIM KADERI",
    "codeMassar": "F188179185",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 218,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.9
  },
  {
    "nom": "CHAIBANE ZAKARIA",
    "codeMassar": "R132889660",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 211,
    "totalAbsences": 7,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.8
  },
  {
    "nom": "YASMINE BENTAZI",
    "codeMassar": "F197207359",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 218,
    "totalAbsences": 7,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 37,
    "totalPresences": 30,
    "totalAbsences": 7,
    "totalRetardMinutes": 0,
    "tauxPresence": 81.1
  },
  {
    "nom": "SAFAA  BAKRAOUI",
    "codeMassar": "F175101585",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 236,
    "totalAbsences": 7,
    "totalRetardMinutes": 55,
    "tauxPresence": 97.1
  },
  {
    "nom": "ANIBA IMRANE",
    "codeMassar": "F177122713",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 236,
    "totalAbsences": 7,
    "totalRetardMinutes": 81,
    "tauxPresence": 97.1
  },
  {
    "nom": "REDOUANi BARAE",
    "codeMassar": "F162087796",
    "niveau": "1BAC Économie",
    "totalSessions": 54,
    "totalPresences": 47,
    "totalAbsences": 7,
    "totalRetardMinutes": 0,
    "tauxPresence": 87.0
  },
  {
    "nom": "MAHA ET TAHALI EL IDRISSI",
    "codeMassar": "F179180183",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 237,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.1
  },
  {
    "nom": "ZAKARIA KARAM",
    "codeMassar": "R147165840",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 174,
    "totalAbsences": 7,
    "totalRetardMinutes": 130,
    "tauxPresence": 96.1
  },
  {
    "nom": "YASSER DRAISS",
    "codeMassar": "F170222868",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 239,
    "totalAbsences": 7,
    "totalRetardMinutes": 205,
    "tauxPresence": 97.2
  },
  {
    "nom": "SARA EL HASANY",
    "codeMassar": "F170140168",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 237,
    "totalAbsences": 7,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.1
  },
  {
    "nom": "AMINA OFKIR",
    "codeMassar": "R130068185",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 181,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.8
  },
  {
    "nom": "AYMANE ARROUB",
    "codeMassar": "F192200384",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 217,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.3
  },
  {
    "nom": "AYA CHAOUKI",
    "codeMassar": "R135737457",
    "niveau": "2BAC PC",
    "totalSessions": 207,
    "totalPresences": 201,
    "totalAbsences": 6,
    "totalRetardMinutes": 60,
    "tauxPresence": 97.1
  },
  {
    "nom": "AIT BELAHCEN IKRAM",
    "codeMassar": "R146194547",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 210,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.2
  },
  {
    "nom": "DOHA SIKI",
    "codeMassar": "F180149473",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 213,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 7,
    "totalPresences": 1,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 14.3
  },
  {
    "nom": "SIFDINE JLIOUI",
    "codeMassar": "R158054405",
    "niveau": "2BAC Économie",
    "totalSessions": 178,
    "totalPresences": 172,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.6
  },
  {
    "nom": "TARIK ZARIAT",
    "codeMassar": "R149066790",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 217,
    "totalAbsences": 6,
    "totalRetardMinutes": 90,
    "tauxPresence": 97.3
  },
  {
    "nom": "BADR TALBI",
    "codeMassar": "F176181929",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 240,
    "totalAbsences": 6,
    "totalRetardMinutes": 216,
    "tauxPresence": 97.6
  },
  {
    "nom": "ANAS CHARMOUKA",
    "codeMassar": "R158001472",
    "niveau": "Tronc Commun",
    "totalSessions": 248,
    "totalPresences": 242,
    "totalAbsences": 6,
    "totalRetardMinutes": 121,
    "tauxPresence": 97.6
  },
  {
    "nom": "MOHAMED ADAM GHAZI",
    "codeMassar": "R140188451",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 217,
    "totalAbsences": 6,
    "totalRetardMinutes": 50,
    "tauxPresence": 97.3
  },
  {
    "nom": "YASSINE IFNOU",
    "codeMassar": "G145080378",
    "niveau": "2BAC PC",
    "totalSessions": 150,
    "totalPresences": 144,
    "totalAbsences": 6,
    "totalRetardMinutes": 30,
    "tauxPresence": 96.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 6,
    "totalPresences": 0,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "CHAOUKI MOHAMMED REDA",
    "codeMassar": "R147183454",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 210,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.2
  },
  {
    "nom": "SABIR EL KABBABI",
    "codeMassar": "R146132698",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 210,
    "totalAbsences": 6,
    "totalRetardMinutes": 230,
    "tauxPresence": 97.2
  },
  {
    "nom": "WASSIM DOROS",
    "codeMassar": "R148166707",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 210,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.2
  },
  {
    "nom": "MEKNI HABACHI CHIRINE",
    "codeMassar": "R151062588",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 175,
    "totalAbsences": 6,
    "totalRetardMinutes": 15,
    "tauxPresence": 96.7
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 9,
    "totalPresences": 3,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 33.3
  },
  {
    "nom": "WALID FARHANE",
    "codeMassar": "R145196642",
    "niveau": "2BAC PC",
    "totalSessions": 209,
    "totalPresences": 203,
    "totalAbsences": 6,
    "totalRetardMinutes": 5,
    "tauxPresence": 97.1
  },
  {
    "nom": "WIAM ABOUARCHE",
    "codeMassar": "F171197696",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 240,
    "totalAbsences": 6,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.6
  },
  {
    "nom": "YOUSSEF EL AOUDI",
    "codeMassar": "R158004727",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 175,
    "totalAbsences": 6,
    "totalRetardMinutes": 40,
    "tauxPresence": 96.7
  },
  {
    "nom": "NADIA GHALLABI",
    "codeMassar": "R149157849",
    "niveau": "2BAC PC",
    "totalSessions": 222,
    "totalPresences": 216,
    "totalAbsences": 6,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 15,
    "totalPresences": 9,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 60.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 16,
    "totalPresences": 10,
    "totalAbsences": 6,
    "totalRetardMinutes": 0,
    "tauxPresence": 62.5
  },
  {
    "nom": "MALAK MARGHICHE",
    "codeMassar": "R157032919",
    "niveau": "2BAC PC",
    "totalSessions": 191,
    "totalPresences": 186,
    "totalAbsences": 5,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.4
  },
  {
    "nom": "IMANE RIJMAOUI",
    "codeMassar": "F164124467",
    "niveau": "1BAC SC",
    "totalSessions": 210,
    "totalPresences": 205,
    "totalAbsences": 5,
    "totalRetardMinutes": 35,
    "tauxPresence": 97.6
  },
  {
    "nom": "HMIRINE RANIA",
    "codeMassar": "R140204813",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 213,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.7
  },
  {
    "nom": "RAYANE BOURASS",
    "codeMassar": "R151034739",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 239,
    "totalAbsences": 5,
    "totalRetardMinutes": 91,
    "tauxPresence": 98.0
  },
  {
    "nom": "ABDERRAZAK KANNOUR",
    "codeMassar": "R130816791",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 198,
    "totalAbsences": 5,
    "totalRetardMinutes": 40,
    "tauxPresence": 97.5
  },
  {
    "nom": "BADR DINE CHOKRI",
    "codeMassar": "R156033271",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 176,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.2
  },
  {
    "nom": "FRISI ADAM",
    "codeMassar": "F170072733",
    "niveau": "Tronc Commun",
    "totalSessions": 115,
    "totalPresences": 110,
    "totalAbsences": 5,
    "totalRetardMinutes": 10,
    "tauxPresence": 95.7
  },
  {
    "nom": "BILAL SAINE",
    "codeMassar": "F169014174",
    "niveau": "Tronc Commun",
    "totalSessions": 233,
    "totalPresences": 228,
    "totalAbsences": 5,
    "totalRetardMinutes": 93,
    "tauxPresence": 97.9
  },
  {
    "nom": "BAHAE HIDARA",
    "codeMassar": "F165103078",
    "niveau": "1BAC SC",
    "totalSessions": 219,
    "totalPresences": 214,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.7
  },
  {
    "nom": "MALAK MARMRI",
    "codeMassar": "R148152560",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 194,
    "totalAbsences": 5,
    "totalRetardMinutes": 35,
    "tauxPresence": 97.5
  },
  {
    "nom": "AYA MOUKHLIS",
    "codeMassar": "F161069402",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 213,
    "totalAbsences": 5,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.7
  },
  {
    "nom": "TAHA HAMDOUNE",
    "codeMassar": "F172193195",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 220,
    "totalAbsences": 5,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.8
  },
  {
    "nom": "YOUSSEF EL BAHRI",
    "codeMassar": "F190223635",
    "niveau": "2AC",
    "totalSessions": 142,
    "totalPresences": 137,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.5
  },
  {
    "nom": "AMIRA ERRADI",
    "codeMassar": "F174193270",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 219,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.8
  },
  {
    "nom": "RANIA EL AMRANI",
    "codeMassar": "R149159662",
    "niveau": "2BAC PC",
    "totalSessions": 220,
    "totalPresences": 215,
    "totalAbsences": 5,
    "totalRetardMinutes": 40,
    "tauxPresence": 97.7
  },
  {
    "nom": "MOUAD BEN-ELJARBOUH",
    "codeMassar": "R152034215",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 205,
    "totalAbsences": 5,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.6
  },
  {
    "nom": "RAYAN EL WADI",
    "codeMassar": "R142205396",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 176,
    "totalAbsences": 5,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.2
  },
  {
    "nom": "MEKKI HARIT",
    "codeMassar": "R143181873",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 185,
    "totalAbsences": 5,
    "totalRetardMinutes": 35,
    "tauxPresence": 97.4
  },
  {
    "nom": "ASSAD RIHAB",
    "codeMassar": "R140183483",
    "niveau": "2BAC PC",
    "totalSessions": 211,
    "totalPresences": 206,
    "totalAbsences": 5,
    "totalRetardMinutes": 20,
    "tauxPresence": 97.6
  },
  {
    "nom": "MARWA BELHAJEB",
    "codeMassar": "F177207521",
    "niveau": "Tronc Commun",
    "totalSessions": 199,
    "totalPresences": 194,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.5
  },
  {
    "nom": "HAJAR ESSIBER",
    "codeMassar": "R142188558",
    "niveau": "2BAC PC",
    "totalSessions": 222,
    "totalPresences": 217,
    "totalAbsences": 5,
    "totalRetardMinutes": 75,
    "tauxPresence": 97.7
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 7,
    "totalPresences": 2,
    "totalAbsences": 5,
    "totalRetardMinutes": 0,
    "tauxPresence": 28.6
  },
  {
    "nom": "ISLAM BAZ",
    "codeMassar": "F179091599",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 215,
    "totalAbsences": 4,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.2
  },
  {
    "nom": "BOUCETTA SALMA",
    "codeMassar": "R140191187",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 214,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.2
  },
  {
    "nom": "YOUSSEF BIBOUDA",
    "codeMassar": "E195062776",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 221,
    "totalAbsences": 4,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.2
  },
  {
    "nom": "MARMRI ADAM",
    "codeMassar": "R144183192",
    "niveau": "2BAC PC",
    "totalSessions": 198,
    "totalPresences": 194,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.0
  },
  {
    "nom": "LINA MOUSTAHCINE",
    "codeMassar": "F171134500",
    "niveau": "Tronc Commun",
    "totalSessions": 242,
    "totalPresences": 238,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.3
  },
  {
    "nom": "JENNAT BASBAS",
    "codeMassar": "R134774200",
    "niveau": "2BAC PC",
    "totalSessions": 209,
    "totalPresences": 205,
    "totalAbsences": 4,
    "totalRetardMinutes": 60,
    "tauxPresence": 98.1
  },
  {
    "nom": "ISSAM REDOUAN",
    "codeMassar": "R138814595",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 183,
    "totalAbsences": 4,
    "totalRetardMinutes": 50,
    "tauxPresence": 97.9
  },
  {
    "nom": "NIIMA LIBANE",
    "codeMassar": "R137720795",
    "niveau": "2BAC PC",
    "totalSessions": 220,
    "totalPresences": 216,
    "totalAbsences": 4,
    "totalRetardMinutes": 160,
    "tauxPresence": 98.2
  },
  {
    "nom": "YOUSSEF MESSAAF",
    "codeMassar": "F157013045",
    "niveau": "2BAC PC",
    "totalSessions": 189,
    "totalPresences": 185,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 4,
    "totalPresences": 0,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "ANAS JAYED",
    "codeMassar": "F179091763",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 240,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.4
  },
  {
    "nom": "HOUSSAM EDAHBI",
    "codeMassar": "R138727201",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 177,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.8
  },
  {
    "nom": "KAMARI AHMED AMINE",
    "codeMassar": "R138830781",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 214,
    "totalAbsences": 4,
    "totalRetardMinutes": 100,
    "tauxPresence": 98.2
  },
  {
    "nom": "RAYANE AJRA",
    "codeMassar": "F174178637",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 215,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.2
  },
  {
    "nom": "KHALDOUNE MONSIF",
    "codeMassar": "R152070417",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 177,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.8
  },
  {
    "nom": "DOUBAJI KHOULOUD",
    "codeMassar": "R154033878",
    "niveau": "Tronc Commun",
    "totalSessions": 135,
    "totalPresences": 131,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.0
  },
  {
    "nom": "SABOUR AYA",
    "codeMassar": "R135736628",
    "niveau": "2BAC PC",
    "totalSessions": 205,
    "totalPresences": 201,
    "totalAbsences": 4,
    "totalRetardMinutes": 40,
    "tauxPresence": 98.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 12,
    "totalPresences": 8,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 66.7
  },
  {
    "nom": "AYMANE EL ABBASSI",
    "codeMassar": "R150068987",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 177,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 97.8
  },
  {
    "nom": "RAKI MED ZIAD",
    "codeMassar": "R147156297",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 212,
    "totalAbsences": 4,
    "totalRetardMinutes": 135,
    "tauxPresence": 98.1
  },
  {
    "nom": "SOUFIANE BANANE",
    "codeMassar": "R145146029",
    "niveau": "2BAC PC",
    "totalSessions": 216,
    "totalPresences": 212,
    "totalAbsences": 4,
    "totalRetardMinutes": 70,
    "tauxPresence": 98.1
  },
  {
    "nom": "HAFSA JAAROUNE",
    "codeMassar": "F172122689",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 240,
    "totalAbsences": 4,
    "totalRetardMinutes": 40,
    "tauxPresence": 98.4
  },
  {
    "nom": "MOHAMEDRIDA RHIBA",
    "codeMassar": "F171196628",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 242,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.4
  },
  {
    "nom": "FATIMAEZAHRA MARBOUH",
    "codeMassar": "F175165901",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 242,
    "totalAbsences": 4,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.4
  },
  {
    "nom": "JANNAT AIT MANSOUR",
    "codeMassar": "F177012233",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 215,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.2
  },
  {
    "nom": "ISMAIL ETTARRASS",
    "codeMassar": "R154080091",
    "niveau": "2BAC Économie",
    "totalSessions": 56,
    "totalPresences": 52,
    "totalAbsences": 4,
    "totalRetardMinutes": 30,
    "tauxPresence": 92.9
  },
  {
    "nom": "MARWA BABAKHALI",
    "codeMassar": "F172021788",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 240,
    "totalAbsences": 4,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.4
  },
  {
    "nom": "NIAMA BOURDOU",
    "codeMassar": "F162013783",
    "niveau": "1BAC SC",
    "totalSessions": 217,
    "totalPresences": 213,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.2
  },
  {
    "nom": "HAMDOUNE AHMED",
    "codeMassar": "R153031725",
    "niveau": "2BAC PC",
    "totalSessions": 76,
    "totalPresences": 72,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 94.7
  },
  {
    "nom": "HAITAM RAITI",
    "codeMassar": "R140198815",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 177,
    "totalAbsences": 4,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.8
  },
  {
    "nom": "RAYANE LAMRANI",
    "codeMassar": "R156048990",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 183,
    "totalAbsences": 4,
    "totalRetardMinutes": 120,
    "tauxPresence": 97.9
  },
  {
    "nom": "ISLAM AIT SALEM",
    "codeMassar": "F187149942",
    "niveau": "3AC",
    "totalSessions": 153,
    "totalPresences": 150,
    "totalAbsences": 3,
    "totalRetardMinutes": 20,
    "tauxPresence": 98.0
  },
  {
    "nom": "ABDE LHAKIM DAOUCHE",
    "codeMassar": "R130056678",
    "niveau": "2BAC Économie",
    "totalSessions": 179,
    "totalPresences": 176,
    "totalAbsences": 3,
    "totalRetardMinutes": 20,
    "tauxPresence": 98.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 6,
    "totalPresences": 3,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 50.0
  },
  {
    "nom": "SAAD LOUAFI",
    "codeMassar": "R144167508",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 196,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.5
  },
  {
    "nom": "HOUALA FAHD",
    "codeMassar": "R130758642",
    "niveau": "1BAC SC",
    "totalSessions": 35,
    "totalPresences": 32,
    "totalAbsences": 3,
    "totalRetardMinutes": 30,
    "tauxPresence": 91.4
  },
  {
    "nom": "ADAM ERRABEHY",
    "codeMassar": "R151001508",
    "niveau": "1BAC SC",
    "totalSessions": 214,
    "totalPresences": 211,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.6
  },
  {
    "nom": "ILYAS NAJI",
    "codeMassar": "F173151546",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 241,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.8
  },
  {
    "nom": "SARA RABOUHI",
    "codeMassar": "R147200224",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 220,
    "totalAbsences": 3,
    "totalRetardMinutes": 156,
    "tauxPresence": 98.7
  },
  {
    "nom": "SOUKAINA BEDAA",
    "codeMassar": "R134751330",
    "niveau": "2BAC PC",
    "totalSessions": 225,
    "totalPresences": 222,
    "totalAbsences": 3,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.7
  },
  {
    "nom": "TIFIDAS WISSAL",
    "codeMassar": "R138760069",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 215,
    "totalAbsences": 3,
    "totalRetardMinutes": 40,
    "tauxPresence": 98.6
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 3,
    "totalPresences": 0,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "BSAIRI LINA",
    "codeMassar": "R2111113",
    "niveau": "2AC",
    "totalSessions": 4,
    "totalPresences": 1,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 25.0
  },
  {
    "nom": "ADAM JABBAR",
    "codeMassar": "F166060097",
    "niveau": "1BAC Économie",
    "totalSessions": 207,
    "totalPresences": 204,
    "totalAbsences": 3,
    "totalRetardMinutes": 50,
    "tauxPresence": 98.6
  },
  {
    "nom": "ELMNYRY SARA",
    "codeMassar": "F163013806",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 240,
    "totalAbsences": 3,
    "totalRetardMinutes": 46,
    "tauxPresence": 98.8
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 31,
    "totalPresences": 28,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 90.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 10,
    "totalPresences": 7,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 70.0
  },
  {
    "nom": "FATIMA ZAHRA KHALILI",
    "codeMassar": "R130015444",
    "niveau": "2BAC PC",
    "totalSessions": 210,
    "totalPresences": 207,
    "totalAbsences": 3,
    "totalRetardMinutes": 20,
    "tauxPresence": 98.6
  },
  {
    "nom": "MOHAMED ALAOUI",
    "codeMassar": "F188200285",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 222,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.7
  },
  {
    "nom": "ASMAA OUAHDANI",
    "codeMassar": "F186149657",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 216,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.6
  },
  {
    "nom": "ISMAIL HABOUBI",
    "codeMassar": "F176015866",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 241,
    "totalAbsences": 3,
    "totalRetardMinutes": 174,
    "tauxPresence": 98.8
  },
  {
    "nom": "YOUSSEF MOUSTARZIK",
    "codeMassar": "R142184524",
    "niveau": "2BAC PC",
    "totalSessions": 139,
    "totalPresences": 136,
    "totalAbsences": 3,
    "totalRetardMinutes": 200,
    "tauxPresence": 97.8
  },
  {
    "nom": "YAHYA TAHOUNE",
    "codeMassar": "F168114296",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 207,
    "totalAbsences": 3,
    "totalRetardMinutes": 5,
    "tauxPresence": 98.6
  },
  {
    "nom": "YAHYA ELJEBRAOUI",
    "codeMassar": "R130118080",
    "niveau": "2BAC PC",
    "totalSessions": 225,
    "totalPresences": 222,
    "totalAbsences": 3,
    "totalRetardMinutes": 60,
    "tauxPresence": 98.7
  },
  {
    "nom": "MOHAMED RAYANE ISLAH",
    "codeMassar": "F163103448",
    "niveau": "Tronc Commun",
    "totalSessions": 110,
    "totalPresences": 107,
    "totalAbsences": 3,
    "totalRetardMinutes": 70,
    "tauxPresence": 97.3
  },
  {
    "nom": "FATIMAZZAHRA DAOUCHE",
    "codeMassar": "F161089351",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 209,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.6
  },
  {
    "nom": "AYMANE LAKOUISS",
    "codeMassar": "R142181272",
    "niveau": "2BAC PC",
    "totalSessions": 210,
    "totalPresences": 207,
    "totalAbsences": 3,
    "totalRetardMinutes": 5,
    "tauxPresence": 98.6
  },
  {
    "nom": "RIHAB HAMDI",
    "codeMassar": "R148183514",
    "niveau": "2BAC PC",
    "totalSessions": 219,
    "totalPresences": 216,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.6
  },
  {
    "nom": "MALAK KARMASSI",
    "codeMassar": "R140136986",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 199,
    "totalAbsences": 3,
    "totalRetardMinutes": 90,
    "tauxPresence": 98.5
  },
  {
    "nom": "IHAM MOHAMED ESSADIK",
    "codeMassar": "R158048957",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 184,
    "totalAbsences": 3,
    "totalRetardMinutes": 50,
    "tauxPresence": 98.4
  },
  {
    "nom": "KHAOULA TOUIRSSA",
    "codeMassar": "R135213216",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 178,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.3
  },
  {
    "nom": "JANNAT EL HOUPI",
    "codeMassar": "J170010868",
    "niveau": "Tronc Commun",
    "totalSessions": 243,
    "totalPresences": 240,
    "totalAbsences": 3,
    "totalRetardMinutes": 100,
    "tauxPresence": 98.8
  },
  {
    "nom": "TAHA SAIH",
    "codeMassar": "F162096449",
    "niveau": "1BAC SC",
    "totalSessions": 211,
    "totalPresences": 208,
    "totalAbsences": 3,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.6
  },
  {
    "nom": "AHMED NASSIRI",
    "codeMassar": "R130156324",
    "niveau": "2BAC PC",
    "totalSessions": 194,
    "totalPresences": 191,
    "totalAbsences": 3,
    "totalRetardMinutes": 70,
    "tauxPresence": 98.5
  },
  {
    "nom": "YOUSSEF YERROUZE",
    "codeMassar": "R145147233",
    "niveau": "2BAC PC",
    "totalSessions": 208,
    "totalPresences": 205,
    "totalAbsences": 3,
    "totalRetardMinutes": 217,
    "tauxPresence": 98.6
  },
  {
    "nom": "HAMZA DRAA",
    "codeMassar": "R155019556",
    "niveau": "Tronc Commun",
    "totalSessions": 213,
    "totalPresences": 210,
    "totalAbsences": 3,
    "totalRetardMinutes": 25,
    "tauxPresence": 98.6
  },
  {
    "nom": "SALMA HAKIK",
    "codeMassar": "R145167353",
    "niveau": "2BAC PC",
    "totalSessions": 225,
    "totalPresences": 222,
    "totalAbsences": 3,
    "totalRetardMinutes": 10,
    "tauxPresence": 98.7
  },
  {
    "nom": "DOHA SEBBAR",
    "codeMassar": "R144182595",
    "niveau": "2BAC PC",
    "totalSessions": 95,
    "totalPresences": 92,
    "totalAbsences": 3,
    "totalRetardMinutes": 220,
    "tauxPresence": 96.8
  },
  {
    "nom": "RIHAB ALGHADIF",
    "codeMassar": "F181136734",
    "niveau": "3AC",
    "totalSessions": 218,
    "totalPresences": 215,
    "totalAbsences": 3,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.6
  },
  {
    "nom": "MOHAMED AMINE RAKIB",
    "codeMassar": "R155057589",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 187,
    "totalAbsences": 3,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.4
  },
  {
    "nom": "ILYAS NAJEM",
    "codeMassar": "R142159267",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 221,
    "totalAbsences": 2,
    "totalRetardMinutes": 105,
    "tauxPresence": 99.1
  },
  {
    "nom": "YOUSSEF OUASSIL",
    "codeMassar": "R157003288",
    "niveau": "3AC",
    "totalSessions": 191,
    "totalPresences": 189,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.0
  },
  {
    "nom": "ADAM ETAJARI",
    "codeMassar": "F178195769",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 244,
    "totalAbsences": 2,
    "totalRetardMinutes": 65,
    "tauxPresence": 99.2
  },
  {
    "nom": "HAYOUK OTHMANE",
    "codeMassar": "F167018943",
    "niveau": "Tronc Commun",
    "totalSessions": 109,
    "totalPresences": 107,
    "totalAbsences": 2,
    "totalRetardMinutes": 60,
    "tauxPresence": 98.2
  },
  {
    "nom": "HASSNA KASSIDI",
    "codeMassar": "R140144382",
    "niveau": "2BAC PC",
    "totalSessions": 167,
    "totalPresences": 165,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.8
  },
  {
    "nom": "MOHAMED FAWAZ KHARBOUTLI",
    "codeMassar": "G141092871",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 217,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 99.1
  },
  {
    "nom": "AIT FAKIR MARWA",
    "codeMassar": "R145159652",
    "niveau": "2BAC PC",
    "totalSessions": 222,
    "totalPresences": 220,
    "totalAbsences": 2,
    "totalRetardMinutes": 230,
    "tauxPresence": 99.1
  },
  {
    "nom": "IMANE KOTBI",
    "codeMassar": "R151077005",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 179,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.9
  },
  {
    "nom": "AMIRA LAZRAK",
    "codeMassar": "R156046475",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 179,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.9
  },
  {
    "nom": "MAHZOUM MOHAMMED YASSER",
    "codeMassar": "R147159014",
    "niveau": "2BAC PC",
    "totalSessions": 226,
    "totalPresences": 224,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "WIAM CHABANI",
    "codeMassar": "F267015422",
    "niveau": "2AC",
    "totalSessions": 182,
    "totalPresences": 180,
    "totalAbsences": 2,
    "totalRetardMinutes": 46,
    "tauxPresence": 98.9
  },
  {
    "nom": "ADAM GRIGIZ",
    "codeMassar": "F194200390",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 223,
    "totalAbsences": 2,
    "totalRetardMinutes": 20,
    "tauxPresence": 99.1
  },
  {
    "nom": "AKHDIM OMAR",
    "codeMassar": "R139889649",
    "niveau": "2BAC PC",
    "totalSessions": 211,
    "totalPresences": 209,
    "totalAbsences": 2,
    "totalRetardMinutes": 20,
    "tauxPresence": 99.1
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 2,
    "totalPresences": 0,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "ACHRAF ZAABOUL",
    "codeMassar": "F186036534",
    "niveau": "2AC",
    "totalSessions": 121,
    "totalPresences": 119,
    "totalAbsences": 2,
    "totalRetardMinutes": 50,
    "tauxPresence": 98.3
  },
  {
    "nom": "OUSSAMA HAIMOUD",
    "codeMassar": "F169088887",
    "niveau": "1BAC SC",
    "totalSessions": 210,
    "totalPresences": 208,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.0
  },
  {
    "nom": "ELACHAB  YOUSSRA",
    "codeMassar": "R135814348",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 216,
    "totalAbsences": 2,
    "totalRetardMinutes": 95,
    "tauxPresence": 99.1
  },
  {
    "nom": "ILYAS ELBEIDORI",
    "codeMassar": "R158034740",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 188,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.9
  },
  {
    "nom": "AMAOUCH SAAD",
    "codeMassar": "R146159801",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 214,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "DOUAA SILA",
    "codeMassar": "R152066213",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 179,
    "totalAbsences": 2,
    "totalRetardMinutes": 25,
    "tauxPresence": 98.9
  },
  {
    "nom": "YAAKOUB EL HINCHI EL AMRANI",
    "codeMassar": "R156062232",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 208,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.0
  },
  {
    "nom": "JABER RAYANE",
    "codeMassar": "F164127641",
    "niveau": "1BAC SC",
    "totalSessions": 74,
    "totalPresences": 72,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 97.3
  },
  {
    "nom": "AYA ASSIRI",
    "codeMassar": "R142046628",
    "niveau": "2BAC PC",
    "totalSessions": 220,
    "totalPresences": 218,
    "totalAbsences": 2,
    "totalRetardMinutes": 135,
    "tauxPresence": 99.1
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 11,
    "totalPresences": 9,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 81.8
  },
  {
    "nom": "YASSER NAJAH",
    "codeMassar": "R157068916",
    "niveau": "2BAC PC",
    "totalSessions": 191,
    "totalPresences": 189,
    "totalAbsences": 2,
    "totalRetardMinutes": 20,
    "tauxPresence": 99.0
  },
  {
    "nom": "AMINA BOULBOUL",
    "codeMassar": "R143138152",
    "niveau": "2BAC PC",
    "totalSessions": 112,
    "totalPresences": 110,
    "totalAbsences": 2,
    "totalRetardMinutes": 80,
    "tauxPresence": 98.2
  },
  {
    "nom": "BOUSTANE DOUAA",
    "codeMassar": "R148142360",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 197,
    "totalAbsences": 2,
    "totalRetardMinutes": 16,
    "tauxPresence": 99.0
  },
  {
    "nom": "BOUTAINA  ADIR",
    "codeMassar": "R149171857",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 210,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "ADAM EL BOUNI",
    "codeMassar": "F176224139",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 244,
    "totalAbsences": 2,
    "totalRetardMinutes": 70,
    "tauxPresence": 99.2
  },
  {
    "nom": "MOUKHLIS ADAM",
    "codeMassar": "R145155833",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 214,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "AYA JAB",
    "codeMassar": "R149204810",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 214,
    "totalAbsences": 2,
    "totalRetardMinutes": 80,
    "tauxPresence": 99.1
  },
  {
    "nom": "ILYASS ELHALABY",
    "codeMassar": "R137895387",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 221,
    "totalAbsences": 2,
    "totalRetardMinutes": 75,
    "tauxPresence": 99.1
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 14,
    "totalPresences": 12,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 85.7
  },
  {
    "nom": "MAATI SEBSAB",
    "codeMassar": "R159066020",
    "niveau": "2BAC PC",
    "totalSessions": 186,
    "totalPresences": 184,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.9
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 2,
    "totalPresences": 0,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "MANSOURI MARWA",
    "codeMassar": "F173072634",
    "niveau": "Tronc Commun",
    "totalSessions": 133,
    "totalPresences": 131,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 98.5
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 5,
    "totalPresences": 3,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 60.0
  },
  {
    "nom": "ANWAR SALAMA",
    "codeMassar": "R157001388",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 216,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "YAHYA FAYEK",
    "codeMassar": "R151062956",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 179,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.9
  },
  {
    "nom": "LOUTFI MALAK",
    "codeMassar": "R151048439",
    "niveau": "2BAC Économie",
    "totalSessions": 168,
    "totalPresences": 166,
    "totalAbsences": 2,
    "totalRetardMinutes": 20,
    "tauxPresence": 98.8
  },
  {
    "nom": "HIBATALLAH ESSETRE",
    "codeMassar": "R140181231",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 200,
    "totalAbsences": 2,
    "totalRetardMinutes": 93,
    "tauxPresence": 99.0
  },
  {
    "nom": "MOHAMMED TAHA METLAOUI",
    "codeMassar": "R154031821",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 188,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 98.9
  },
  {
    "nom": "DRAFAT FADWA",
    "codeMassar": "R149159962",
    "niveau": "2BAC PC",
    "totalSessions": 211,
    "totalPresences": 209,
    "totalAbsences": 2,
    "totalRetardMinutes": 114,
    "tauxPresence": 99.1
  },
  {
    "nom": "CHADA CHAWKI",
    "codeMassar": "R150075258",
    "niveau": "2BAC PC",
    "totalSessions": 191,
    "totalPresences": 189,
    "totalAbsences": 2,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.0
  },
  {
    "nom": "SOUHAIL ARROUB",
    "codeMassar": "R146167546",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 179,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 98.9
  },
  {
    "nom": "MED ISLAM BOUIHI",
    "codeMassar": "F197193748",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 223,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "ZIAD LAKHMIRI",
    "codeMassar": "F182121868",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 221,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "CAMILIA LAKHAL",
    "codeMassar": "F161056166",
    "niveau": "1BAC SC",
    "totalSessions": 35,
    "totalPresences": 33,
    "totalAbsences": 2,
    "totalRetardMinutes": 30,
    "tauxPresence": 94.3
  },
  {
    "nom": "ZAKARIA BOUAYAD",
    "codeMassar": "F169058822",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 210,
    "totalAbsences": 2,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.1
  },
  {
    "nom": "KOURKOUZ ISRAA",
    "codeMassar": "G176126988",
    "niveau": "Tronc Commun",
    "totalSessions": 44,
    "totalPresences": 43,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.7
  },
  {
    "nom": "AYMEN CHAHAD",
    "codeMassar": "F180169326",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 218,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.5
  },
  {
    "nom": "NISSRINE EL ASSI",
    "codeMassar": "F166103804",
    "niveau": "1BAC SC",
    "totalSessions": 217,
    "totalPresences": 216,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.5
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 1,
    "totalPresences": 0,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "WALAA MARDAD",
    "codeMassar": "F250008075",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 245,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "MOUSTAPHA  AZAZE",
    "codeMassar": "R153001495",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 209,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.5
  },
  {
    "nom": "MERYEM DINAR",
    "codeMassar": "R148173083",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 198,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "FARI RAYANE",
    "codeMassar": "R148159377",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 215,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "ADAM CHWAQUI",
    "codeMassar": "R143137206",
    "niveau": "2BAC PC",
    "totalSessions": 223,
    "totalPresences": 222,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "ZIYAD KOUNIMA",
    "codeMassar": "F174034864",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 218,
    "totalAbsences": 1,
    "totalRetardMinutes": 30,
    "tauxPresence": 99.5
  },
  {
    "nom": "FATIMA ZAHRA DINAR",
    "codeMassar": "F170224157",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 245,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 29,
    "totalPresences": 28,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.6
  },
  {
    "nom": "IMANE BAHRI",
    "codeMassar": "R134808807",
    "niveau": "2BAC PC",
    "totalSessions": 200,
    "totalPresences": 199,
    "totalAbsences": 1,
    "totalRetardMinutes": 80,
    "tauxPresence": 99.5
  },
  {
    "nom": "MANBAL OUSSAMA",
    "codeMassar": "F187173099",
    "niveau": "3AC",
    "totalSessions": 170,
    "totalPresences": 169,
    "totalAbsences": 1,
    "totalRetardMinutes": 5,
    "tauxPresence": 99.4
  },
  {
    "nom": "ISHAK MOUSTAHCINE",
    "codeMassar": "R150068870",
    "niveau": "2BAC PC",
    "totalSessions": 183,
    "totalPresences": 182,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.5
  },
  {
    "nom": "ADAM ARMACH",
    "codeMassar": "F195014746",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 223,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "ASMAA MARBOUH",
    "codeMassar": "F175165902",
    "niveau": "Tronc Commun",
    "totalSessions": 247,
    "totalPresences": 246,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.6
  },
  {
    "nom": "SABRINE CHAOUACH",
    "codeMassar": "F171123539",
    "niveau": "2AC",
    "totalSessions": 36,
    "totalPresences": 35,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.2
  },
  {
    "nom": "CHAMSEDDINE BRAIJA",
    "codeMassar": "F172181485",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 243,
    "totalAbsences": 1,
    "totalRetardMinutes": 30,
    "tauxPresence": 99.6
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 1,
    "totalPresences": 0,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "GHICHA AHMED RAYAN",
    "codeMassar": "F167096381",
    "niveau": "1BAC SC",
    "totalSessions": 213,
    "totalPresences": 212,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "AMARIR SARA",
    "codeMassar": "R152048356",
    "niveau": "2BAC Économie",
    "totalSessions": 29,
    "totalPresences": 28,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 96.6
  },
  {
    "nom": "YAHYA ADDAY",
    "codeMassar": "F167057474",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 217,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "BELHAJEB DOUAA",
    "codeMassar": "F194187556",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 222,
    "totalAbsences": 1,
    "totalRetardMinutes": 5,
    "tauxPresence": 99.6
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 1,
    "totalPresences": 0,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "SAAD SEBTI",
    "codeMassar": "R134737255.",
    "niveau": "2BAC PC",
    "totalSessions": 225,
    "totalPresences": 224,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "MERIEM CHOUKLAT",
    "codeMassar": "F187105932",
    "niveau": "3AC",
    "totalSessions": 194,
    "totalPresences": 193,
    "totalAbsences": 1,
    "totalRetardMinutes": 5,
    "tauxPresence": 99.5
  },
  {
    "nom": "MARWA TALOUB",
    "codeMassar": "R139714282",
    "niveau": "2BAC PC",
    "totalSessions": 139,
    "totalPresences": 138,
    "totalAbsences": 1,
    "totalRetardMinutes": 80,
    "tauxPresence": 99.3
  },
  {
    "nom": "LINA HADIR",
    "codeMassar": "R152058317",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 180,
    "totalAbsences": 1,
    "totalRetardMinutes": 70,
    "tauxPresence": 99.4
  },
  {
    "nom": "ZAKARIA EL IDRISSI",
    "codeMassar": "F181147476",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 218,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "AMIRA MAHER",
    "codeMassar": "F189145426",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 223,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "MERIEM EL MEJHED",
    "codeMassar": "F192146607",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 224,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "MOHAMED AMINE ENOURI",
    "codeMassar": "F177166794",
    "niveau": "Tronc Commun",
    "totalSessions": 244,
    "totalPresences": 243,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 1,
    "totalPresences": 0,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 0.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 11,
    "totalPresences": 10,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 90.9
  },
  {
    "nom": "ABDERRAHMANE MNAYHI",
    "codeMassar": "F162143456",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 217,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "HAJAR AIT OMAR",
    "codeMassar": "F163130856",
    "niveau": "1BAC SC",
    "totalSessions": 215,
    "totalPresences": 214,
    "totalAbsences": 1,
    "totalRetardMinutes": 20,
    "tauxPresence": 99.5
  },
  {
    "nom": "IMRANE KHEZZAR",
    "codeMassar": "F175182907",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 222,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.6
  },
  {
    "nom": "ECHINE MOHAMED TAHA",
    "codeMassar": "R147166727",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 217,
    "totalAbsences": 1,
    "totalRetardMinutes": 20,
    "tauxPresence": 99.5
  },
  {
    "nom": "MARWA BOURDOU",
    "codeMassar": "P142153786",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 198,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "DOUAE KHOUBBANE",
    "codeMassar": "R152065244",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 211,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.5
  },
  {
    "nom": "BILAL SAIL",
    "codeMassar": "R140136939",
    "niveau": "2BAC Économie",
    "totalSessions": 179,
    "totalPresences": 178,
    "totalAbsences": 1,
    "totalRetardMinutes": 15,
    "tauxPresence": 99.4
  },
  {
    "nom": "NAJIB DELLAHA",
    "codeMassar": "F178095112",
    "niveau": "Tronc Commun",
    "totalSessions": 35,
    "totalPresences": 34,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 97.1
  },
  {
    "nom": "BOUDARGA TAHA",
    "codeMassar": "R143152647",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 215,
    "totalAbsences": 1,
    "totalRetardMinutes": 30,
    "tauxPresence": 99.5
  },
  {
    "nom": "DOUAA ALLAM",
    "codeMassar": "R130063653",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 202,
    "totalAbsences": 1,
    "totalRetardMinutes": 78,
    "tauxPresence": 99.5
  },
  {
    "nom": "MALAK EL MOUCH",
    "codeMassar": "R141185298",
    "niveau": "2BAC PC",
    "totalSessions": 144,
    "totalPresences": 143,
    "totalAbsences": 1,
    "totalRetardMinutes": 30,
    "tauxPresence": 99.3
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 13,
    "totalPresences": 12,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 92.3
  },
  {
    "nom": "KHALIL LEMGANI",
    "codeMassar": "R157064922",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 180,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 99.4
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 14,
    "totalPresences": 13,
    "totalAbsences": 1,
    "totalRetardMinutes": 0,
    "tauxPresence": 92.9
  },
  {
    "nom": "YOUNESS AIT AHMED",
    "codeMassar": "F168126502",
    "niveau": "1BAC SC",
    "totalSessions": 218,
    "totalPresences": 218,
    "totalAbsences": 0,
    "totalRetardMinutes": 5,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 14,
    "totalPresences": 14,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "YOUSSEF KHABTOU",
    "codeMassar": "R154034265",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "WISSAL ROUDALI",
    "codeMassar": "R155004371",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "AMANE MARWA",
    "codeMassar": "F176244433",
    "niveau": "Tronc Commun",
    "totalSessions": 68,
    "totalPresences": 68,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "NADA HAMDOUNE",
    "codeMassar": "R158074001",
    "niveau": "2BAC Économie",
    "totalSessions": 182,
    "totalPresences": 182,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "SARA TALALI",
    "codeMassar": "R148152582",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 203,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "EL MORHIR IBTISSAM",
    "codeMassar": "R141152474",
    "niveau": "2BAC Économie",
    "totalSessions": 131,
    "totalPresences": 131,
    "totalAbsences": 0,
    "totalRetardMinutes": 45,
    "tauxPresence": 100.0
  },
  {
    "nom": "MALAK AIT MANSOUR",
    "codeMassar": "R149189279",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 203,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "MOHAMED AMINE GOUALE",
    "codeMassar": "F180067245",
    "niveau": "3AC",
    "totalSessions": 219,
    "totalPresences": 219,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "YAHYA BOUTSKAOUT",
    "codeMassar": "R147143763",
    "niveau": "2BAC PC",
    "totalSessions": 222,
    "totalPresences": 222,
    "totalAbsences": 0,
    "totalRetardMinutes": 65,
    "tauxPresence": 100.0
  },
  {
    "nom": "HAWMI KHADIJA",
    "codeMassar": "R158057569",
    "niveau": "2BAC Économie",
    "totalSessions": 158,
    "totalPresences": 158,
    "totalAbsences": 0,
    "totalRetardMinutes": 95,
    "tauxPresence": 100.0
  },
  {
    "nom": "HOUSSAM OUANZARI",
    "codeMassar": "R142152624",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "FATIMAEZZAHRAE MENI",
    "codeMassar": "R150036616",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 45,
    "tauxPresence": 100.0
  },
  {
    "nom": "ISRAA LABDOURI",
    "codeMassar": "F168042382",
    "niveau": "Tronc Commun",
    "totalSessions": 31,
    "totalPresences": 31,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "MAROUAN ASSAKHI",
    "codeMassar": "F170056346",
    "niveau": "Tronc Commun",
    "totalSessions": 134,
    "totalPresences": 134,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "SONDOSS EL MAYMOUNY",
    "codeMassar": "G173132630",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 225,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ZINEB BESSA",
    "codeMassar": "R147170127",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "MOHAMMED NAJAH",
    "codeMassar": "R143165119",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "SALMA BEN RAISE",
    "codeMassar": "R146194545",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 246,
    "totalAbsences": 0,
    "totalRetardMinutes": 5,
    "tauxPresence": 100.0
  },
  {
    "nom": "WALID HANIF",
    "codeMassar": "R130016922",
    "niveau": "2BAC PC",
    "totalSessions": 210,
    "totalPresences": 210,
    "totalAbsences": 0,
    "totalRetardMinutes": 70,
    "tauxPresence": 100.0
  },
  {
    "nom": "ISRAA SILA",
    "codeMassar": "F183135439",
    "niveau": "2AC",
    "totalSessions": 223,
    "totalPresences": 223,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 1,
    "totalPresences": 1,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "YASMINE MOKHDIM",
    "codeMassar": "R143164837",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 187,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "AYOUB CHOUKLAT",
    "codeMassar": "F126069205",
    "niveau": "1BAC SC",
    "totalSessions": 208,
    "totalPresences": 208,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ADNANE ENNASSIRI",
    "codeMassar": "F160103871",
    "niveau": "2AC",
    "totalSessions": 224,
    "totalPresences": 224,
    "totalAbsences": 0,
    "totalRetardMinutes": 70,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 9,
    "totalPresences": 9,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "FATIMA AZAHRA JDOUR",
    "codeMassar": "R152041076",
    "niveau": "2BAC PC",
    "totalSessions": 187,
    "totalPresences": 187,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 2,
    "totalPresences": 2,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "MOUADNI MOHAMED AMINE",
    "codeMassar": "R150058928",
    "niveau": "2BAC PC",
    "totalSessions": 15,
    "totalPresences": 15,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 35,
    "totalPresences": 35,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "KHETTABI MALAK",
    "codeMassar": "F166070144",
    "niveau": "Tronc Commun",
    "totalSessions": 13,
    "totalPresences": 13,
    "totalAbsences": 0,
    "totalRetardMinutes": 5,
    "tauxPresence": 100.0
  },
  {
    "nom": "MARMRI AYMEN",
    "codeMassar": "F166143455",
    "niveau": "1BAC SC",
    "totalSessions": 217,
    "totalPresences": 217,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "NAJEM AIT RAOUI",
    "codeMassar": "R158047895",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "YASMINE ERBIBI",
    "codeMassar": "F193157609",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 225,
    "totalAbsences": 0,
    "totalRetardMinutes": 65,
    "tauxPresence": 100.0
  },
  {
    "nom": "SAAD MARDAD",
    "codeMassar": "F256008069",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 190,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "AZIZA GHANDARI",
    "codeMassar": "R140014621",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 202,
    "totalAbsences": 0,
    "totalRetardMinutes": 55,
    "tauxPresence": 100.0
  },
  {
    "nom": "ZIYAD CHAWKI",
    "codeMassar": "F184158349",
    "niveau": "3AC",
    "totalSessions": 218,
    "totalPresences": 218,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "TIYAB MOHAMED RAYANE",
    "codeMassar": "R150069744",
    "niveau": "2BAC PC",
    "totalSessions": 94,
    "totalPresences": 94,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "AYOUB DIB",
    "codeMassar": "R142173012",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 216,
    "totalAbsences": 0,
    "totalRetardMinutes": 5,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 3,
    "totalPresences": 3,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 2,
    "totalPresences": 2,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "HINCHI AMRANI JAWAHIR",
    "codeMassar": "F195201784",
    "niveau": "2AC",
    "totalSessions": 183,
    "totalPresences": 183,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "HIBA MOUFKI",
    "codeMassar": "R141098202",
    "niveau": "2BAC PC",
    "totalSessions": 202,
    "totalPresences": 202,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "NAIMI AYMEN",
    "codeMassar": "F185190974",
    "niveau": "3AC",
    "totalSessions": 27,
    "totalPresences": 27,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "MARWA AKOUCHI",
    "codeMassar": "F168108397",
    "niveau": "1BAC SC",
    "totalSessions": 211,
    "totalPresences": 211,
    "totalAbsences": 0,
    "totalRetardMinutes": 5,
    "tauxPresence": 100.0
  },
  {
    "nom": "CHAÏMAE BOUSSAIDA",
    "codeMassar": "F161014504",
    "niveau": "1BAC SC",
    "totalSessions": 209,
    "totalPresences": 209,
    "totalAbsences": 0,
    "totalRetardMinutes": 25,
    "tauxPresence": 100.0
  },
  {
    "nom": "MANAL TANAN",
    "codeMassar": "R149155463",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "YAHYA ASSAB",
    "codeMassar": "C131000678",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 218,
    "totalAbsences": 0,
    "totalRetardMinutes": 60,
    "tauxPresence": 100.0
  },
  {
    "nom": "MOHAMED TAHA BENHAJJAM",
    "codeMassar": "R147204814",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 203,
    "totalAbsences": 0,
    "totalRetardMinutes": 65,
    "tauxPresence": 100.0
  },
  {
    "nom": "JANNAT DOUJAJI",
    "codeMassar": "F172164080",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 246,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ANAS BOUKHLISS",
    "codeMassar": "F168143571",
    "niveau": "1BAC SC",
    "totalSessions": 219,
    "totalPresences": 219,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "YAHYA ELABID",
    "codeMassar": "R152076768",
    "niveau": "2BAC Économie",
    "totalSessions": 177,
    "totalPresences": 177,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "NACEREDDINE ZIANI",
    "codeMassar": "F171057613",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 246,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ILYASS AIT AHMED",
    "codeMassar": "R151077006",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 190,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 2,
    "totalPresences": 2,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ROKAYA MAHIOUB",
    "codeMassar": "R150051955",
    "niveau": "2BAC PC",
    "totalSessions": 190,
    "totalPresences": 190,
    "totalAbsences": 0,
    "totalRetardMinutes": 60,
    "tauxPresence": 100.0
  },
  {
    "nom": "MAROUANE HAMDOUN",
    "codeMassar": "R136840206",
    "niveau": "2BAC PC",
    "totalSessions": 226,
    "totalPresences": 226,
    "totalAbsences": 0,
    "totalRetardMinutes": 77,
    "tauxPresence": 100.0
  },
  {
    "nom": "NOUHAILA BAKKAR",
    "codeMassar": "R143204599",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "RAYANE MOUSTAQUIM",
    "codeMassar": "F177216618",
    "niveau": "2AC",
    "totalSessions": 225,
    "totalPresences": 225,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ADAM BENÄZIZ",
    "codeMassar": "F165142584",
    "niveau": "1BAC Économie",
    "totalSessions": 210,
    "totalPresences": 210,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "YAHYA BADY",
    "codeMassar": "F170015400",
    "niveau": "Tronc Commun",
    "totalSessions": 246,
    "totalPresences": 246,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ASMAA ZANBOR",
    "codeMassar": "R147167572",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "BADR ZAABOUL",
    "codeMassar": "R153042668",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 55,
    "tauxPresence": 100.0
  },
  {
    "nom": "YASSER KANFOUD",
    "codeMassar": "R142199833",
    "niveau": "2BAC PC",
    "totalSessions": 199,
    "totalPresences": 199,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "LECHHAB IMAD",
    "codeMassar": "R156023637",
    "niveau": "2BAC Économie",
    "totalSessions": 181,
    "totalPresences": 181,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ZAKARIA EL BOUNI",
    "codeMassar": "R131796435",
    "niveau": "2BAC Économie",
    "totalSessions": 218,
    "totalPresences": 218,
    "totalAbsences": 0,
    "totalRetardMinutes": 55,
    "tauxPresence": 100.0
  },
  {
    "nom": "FADIL NIZAR",
    "codeMassar": "R153058926",
    "niveau": "2BAC PC",
    "totalSessions": 31,
    "totalPresences": 31,
    "totalAbsences": 0,
    "totalRetardMinutes": 30,
    "tauxPresence": 100.0
  },
  {
    "nom": "HICHAM ZRYRA",
    "codeMassar": "R148152954",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 216,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  },
  {
    "nom": "SALMA ERBIBI",
    "codeMassar": "F167052050",
    "niveau": "1BAC SC",
    "totalSessions": 212,
    "totalPresences": 212,
    "totalAbsences": 0,
    "totalRetardMinutes": 95,
    "tauxPresence": 100.0
  },
  {
    "nom": "SABRINE JEBBAR",
    "codeMassar": "R130834299",
    "niveau": "2BAC PC",
    "totalSessions": 203,
    "totalPresences": 203,
    "totalAbsences": 0,
    "totalRetardMinutes": 55,
    "tauxPresence": 100.0
  },
  {
    "nom": "HLLAM TOUFIK",
    "codeMassar": "F167124409",
    "niveau": "Tronc Commun",
    "totalSessions": 13,
    "totalPresences": 13,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "Etudiant introuvable",
    "codeMassar": "—",
    "niveau": "Non spécifié",
    "totalSessions": 14,
    "totalPresences": 14,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ALAMI  KOUYES SALMANE",
    "codeMassar": "R148158229",
    "niveau": "2BAC PC",
    "totalSessions": 157,
    "totalPresences": 157,
    "totalAbsences": 0,
    "totalRetardMinutes": 225,
    "tauxPresence": 100.0
  },
  {
    "nom": "CHAIMAA LYAMI",
    "codeMassar": "R139820048",
    "niveau": "2BAC PC",
    "totalSessions": 205,
    "totalPresences": 205,
    "totalAbsences": 0,
    "totalRetardMinutes": 0,
    "tauxPresence": 100.0
  },
  {
    "nom": "ADAM BENKHAYI",
    "codeMassar": "R140159227",
    "niveau": "2BAC Économie",
    "totalSessions": 216,
    "totalPresences": 216,
    "totalAbsences": 0,
    "totalRetardMinutes": 15,
    "tauxPresence": 100.0
  }
];